<template>
  <div class="py-2">
    <b-form @submit.prevent="IsSubmit()">
      <b-row>
        <!-- <p class="component-heading">{{ $t("item.items") }}</p> -->
        <!-- <b-col lg="3" md="4" sm="6" v-if="showFields.Category">
        <div class="field">
          <label>Item Category</label>
          <Dropdown placeholder="Select Category" v-model="ItemData.CategoryId" :items="LoadCategoryName.Categoryoption"
            @update:modelValue="CategoryOnChange" />
        </div>
      </b-col> -->
        <b-col lg="4" md="4" sm="6" cols="12" v-if="showFields.Name?.show">
          <div class="d-flex align-items-center">
            <div class="field w-100">
              <label>{{ $t("item.itemname") }}<span class="red"> *</span></label>
              <AutoCompleteCustom v-model="ItemData.Itemname1" :items="LoadItemName.ITEMoption" @input="
                consumeOrService == '2'
                  ? LoadItem()
                  : loadBasedonConsumeOrService()
                " class="autoItem" @item-select="ItemOnChange" name="Item name" id="Item name"
                :optionAttrs="(item) => ({ extraValue: item.ItemQuantity })" :disabled="itemDisabled"
                :rules="{ required: true }" :required-icon="true" />
            </div>
            <Button @click="(ItemInfoPop = true), getSupplierDetailsItemId(ItemData)" icon="pi pi-info-circle"
              class="p-button-rounded editicon p-button-text mt-4" v-if="ItemInfoIcon && commonItemProps.POFlag" />
            <Button @click="GetLastTransactionDetails(ItemData)" icon="pi pi-info-circle"
              class="p-button-rounded editicon p-button-text mt-4" v-if="ItemLastTransicon == true" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.IssueNo?.show">
          <div class="field">
            <DropdownCustom :label="$t('item.issueno')" v-model="ItemData.IssueId" :items="LoadIssueNo.IssueNoOption"
              :rules="{ required: showFields.IssueNo?.require }" :required-icon="showFields.IssueNo?.require"
              name="IssueNo" id="IssueNo" @update:modelValue="DocNoOnchange" />
          </div>
        </b-col>

        <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.Brand?.show">
          <div class="field">
            <DropdownCustom :label="$t('item.brand')" v-model="ItemData.Brand" :items="BrandDropdown.ItemBrandoption"
              :placeholder="$t('item.selectbrand')" @update:modelValue="BrandOnChange" :rules="{
                required:
                  ItemData.IsBrand == true ? true : showFields.Size?.require,
              }" :required-icon="ItemData.IsBrand == true ? true : showFields.Size?.require
                " name="Brand" id="Brand" :disabled="itemConfigDisabled" />
          </div>
        </b-col>
        <b-col lg="4" md="3" sm="6" cols="12" v-if="showFields.ModelNumber?.show">
          <div class="field">
            <DropdownCustom :label="$t('item.model/catalog number')" v-model="ItemData.ModelNumber"
              :items="ModelNumberDropdown.ItemModelNumberoption" :placeholder="$t('item.selectmodelnumber')"
              @update:modelValue="ModelNumberOnChange" :rules="{
                required:
                  ItemData.IsModel == true ? true : showFields.Size?.require,
              }" :required-icon="ItemData.IsModel == true ? true : showFields.Size?.require
                " name="Model Number" id="Model Number" :disabled="itemConfigDisabled" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.Size?.show">
          <div class="field">
            <DropdownCustom :label="$t('item.size')" v-model="ItemData.Size" :items="SizeDropdown.ItemSizeoption"
              :placeholder="$t('item.selectsize')" @update:modelValue="SizeOnChange" :rules="{
                required:
                  ItemData.IsSize == true ? true : showFields.Size?.require,
              }" :required-icon="ItemData.IsSize == true ? true : showFields.Size?.require
                " name="Size" id="Size" :disabled="itemConfigDisabled" />
          </div>
        </b-col>

        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.Qty?.show">
          <div class="field">
            <TextField :label="$t('item.quantity')" v-model="ItemData.ItemQuantity" type="text" :rules="{
              nonnegative: true,
              decimal: true,
              required: true,
              nonzeroable: true,
            }" :placeholder="$t('item.enterqty')" clearable name="Quantity" id="Quantity"
              :required-icon="showFields.Qty?.require" />
          </div>
        </b-col>
        <b-col lg="3" md="4" sm="6" cols="12" class="position-relative"
          v-if="showFields.Batch?.show && ItemFields.BatchRequired">
          <div class="field">
            <TextField :label="$t('item.batchno')" v-model="ItemData.BatchNo" type="text"
              :placeholder="$t('item.enterbatchno')" clearable name="BatchNo" id="BatchNo"
              :rules="{ required: showFields.Batch?.require }" :required-icon="showFields.Batch?.require"
              :disabled="FieldDisabled.Batch" @keyupenter="handleEnterPress" @keyup="BatchNokeyup" />
          </div>
          <InputSwitch v-model="ItemData.BatchChecked" class="itemdata-checked" />
        </b-col>
        <b-col lg="3" md="4" sm="6" cols="12" class="position-relative" v-if="showFields.SupplierBarCode?.show">
          <div class="field">
            <TextField :label="$t('item.supplierbarcode')" v-model="ItemData.SupplierBarCode" type="text"
              :placeholder="$t('item.supplierbarcode')" clearable name="SupplierBarCode" id="SupplierBarCode" />
          </div>
          <InputSwitch v-model="ItemData.SupplierChecked" class="itemdata-checked" @change="SupplierCheckedOnChange" />
        </b-col>
        <b-col lg="3" md="4" sm="6" cols="8" v-if="showFields.ExpiryDate?.show && ItemFields.ExpiryDtRequired">
          <div class="field">
            <Datepicker :label="$t('item.expirydate')" v-model="ItemData.ExpiryDate" name="ExpiryDate" id="ExpiryDate"
              :required-icon="showFields.ExpiryDate?.require" :rules="{ required: showFields.ExpiryDate?.require }"
              :disabled="FieldDisabled.ExpiryDate" :minDate="minExpiryDate" />
            <!-- :rules="{ required: ItemData.BatchNo ? showFields.ExpiryDate?.require : false }" -->
          </div>
        </b-col>
        <!-- <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.PackSize?.show">
          <div class="field">

            <DropdownCustom :label="$t('item.packsize')" v-model="ItemData.PackSizeId"
              :items="LoadPackSize.packagesizeoption" :placeholder="$t('item.selectpackagesize')"
              @update:modelValue="PackageSizeOnChange" :rules="{ required: showFields.PackSize?.require }"
              :required-icon="showFields.PackSize?.require" name="PackSize" id="PackSize" />
          </div>
        </b-col> -->
        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.RequestedQty?.show">
          <div class="field">
            <TextField :label="$t('item.requestedquantity')" v-model="ItemData.RequestedQty" type="text" :rules="{
              numeric: true,
              required: showFields.RequestedQty?.require,
            }" :required-icon="showFields.RequestedQty?.require" :placeholder="$t('item.enterqty')" clearable
              name="RequestedQty" id="RequestedQty" disabled />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.IssuedQty?.show">
          <div class="field">
            <TextField :label="showFields.IssuedQty?.fieldName
              ? showFields.IssuedQty?.fieldName
              : $t('item.issuedquantity')
              " v-model="ItemData.IssuedQty" type="text" :rules="{
                numeric: true,
                required: showFields.IssuedQty?.require,
              }" :required-icon="showFields.IssuedQty?.require" :placeholder="$t('item.enterqty')" clearable
              name="IssuedQty" id="IssuedQty" disabled />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.GrnAvlQty?.show">
          <div class="field">
            <TextField :label="$t('item.grnquantity')" v-model="ItemData.GrnAvlQty" type="text" :rules="{
              decimal: true,
              required: showFields.GrnAvlQty?.require,
            }" :required-icon="showFields.GrnAvlQty?.require" :placeholder="$t('item.enterqty')" clearable
              name="GrnQuantity" id="GrnQuantity" disabled />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.GrnAvlQty?.show">
          <div class="field">
            <TextField :label="$t('item.receivedquantity')" v-model="ItemData.GRNRecQty" type="text" :rules="{
              numeric: true,
            }" :placeholder="$t('item.enterqty')" clearable name="ReceivedQuantity" id="ReceivedQuantity" disabled />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.UOM?.show">
          <div class="field">
            <DropdownCustom :label="$t('item.uom')" v-model="ItemData.UOM" :items="LoadUOM.UOMoption"
              :placeholder="$t('item.selectuom')" @update:modelValue="UOMOnChange"
              :rules="{ required: showFields.UOM?.require }" :required-icon="showFields.UOM?.require" name="UOM"
              id="UOM" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.AvailQty?.show">
          <div class="field">
            <TextField :label="$t('item.availabequantity')" v-model="ItemData.StockInHand" type="text"
              :rules="{ decimal: true, required: showFields.AvailQty?.require }" :placeholder="$t('item.enterqty')"
              clearable name="AvailQty" id="AvailQty" :required-icon="showFields.AvailQty?.require" disabled />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.UnitRate?.show">
          <div class="field">
            <TextField :label="$t('item.unitrate')" v-model="ItemData.UnitRate" type="text"
              :placeholder="$t('item.enterunitrate')" clearable
              :disabled="ItemData.IsContractStatus == 1 ? true : false" :rules="{
                decimal: true,
                required:
                  $route.query.IsZeroBill == 'true'
                    ? false
                    : showFields.UnitRate?.require,
                nonzeroable:
                  UnitRateZero == 1 && $route.query.IsZeroBill == 'true'
                    ? false
                    : true,
              }" :required-icon="UnitRateZero == 1 && $route.query.IsZeroBill == 'true'
                ? false
                : showFields.UnitRate?.require
                " name="UnitRate" id="UnitRate" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.MRP?.show">
          <div class="field">
            <TextField :label="$t('item.mrp')" v-model="ItemData.MRP" type="text" :placeholder="$t('item.entermrp')"
              clearable :rules="{
                decimal: true,
                required:
                  $route.query.IsZeroBill == 'true'
                    ? false
                    : showFields.MRP?.require,
                nonzeroable:
                  UnitRateZero == 1 && $route.query.IsZeroBill == 'true'
                    ? false
                    : true,
              }" :required-icon="UnitRateZero == 1 && $route.query.IsZeroBill == 'true'
                ? false
                : showFields.MRP?.require
                " name="MRP" id="MRP" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="8" v-if="showFields.Discount?.show">
          <div class="field">
            <TextField :label="$t('item.discount')" v-model="ItemData.Discount" type="text"
              :placeholder="$t('item.enterdiscount')" clearable name="Discount" id="Discount" :rules="{
                decimal: true,
                required: showFields.Discount?.require,
                percentage: true,
              }" :required-icon="showFields.Discount?.require" />
          </div>
        </b-col>
        <b-col lg="3" md="4" sm="6" cols="12" v-if="showFields.FromDate?.show">
          <div class="field">
            <label>From Date</label>
            <Datepicker :label="$t('item.fromdate')" v-model="ItemData.FromDate" name="FromDate" id="FromDate"
              :required-icon="showFields.FromDate?.require" :rules="{ required: showFields.FromDate?.require }" />
          </div>
        </b-col>
        <b-col lg="3" md="4" sm="6" cols="8" v-if="showFields.ToDate?.show">
          <div class="field">
            <label>To Date</label>
            <Datepicker :label="$t('item.todate')" v-model="ItemData.ToDate" name="ToDate" id="ToDate"
              :required-icon="showFields.ToDate?.require" :rules="{ required: showFields.ToDate?.require }" />
          </div>
        </b-col>
        <b-col lg="3" md="4" sm="6" cols="8" v-if="
          showFields.ManufactureDt?.show && ItemFields.ManufactureDtRequired
        ">
          <div class="field">
            <Datepicker :label="$t('item.manufacturedt')" v-model="ItemData.ManufactureDate" name="ManufactureDt"
              id="ManufactureDt" :required-icon="showFields.ManufactureDt?.require"
              :rules="{ required: showFields.ManufactureDt?.require }" :maxDate="maxDate" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.transportcharges?.show">
          <div class="field">
            <TextField :label="$t('item.tranportation')" v-model="ItemData.transportcharges" type="text"
              :placeholder="$t('item.enterdiscount')" clearable name="transportcharges" id="transportcharges"
              :required-icon="showFields.transportcharges?.require"
              :rules="{ required: showFields.transportcharges?.require }" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.servicecharges?.show">
          <div class="field">
            <TextField :label="$t('item.servicecharges')" v-model="ItemData.servicecharges" type="text"
              :placeholder="$t('item.enterdiscount')" clearable name="servicecharges" id="servicecharges"
              :required-icon="showFields.servicecharges?.require" :rules="{
                required: showFields.servicecharges?.require,
                decimal: true,
              }" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.othercharges?.show">
          <div class="field">
            <TextField :label="$t('item.othercharges')" v-model="ItemData.othercharges" type="text"
              :placeholder="$t('item.enterdiscount')" clearable name="othercharges" id="othercharges"
              :required-icon="showFields.othercharges?.require" :rules="{
                required: showFields.othercharges?.require,
                decimal: true,
              }" />
          </div>
        </b-col>
        <b-col lg="2" md="3" sm="6" cols="12" v-if="showFields.Reason?.show">
          <div class="field">
            <DropdownCustom :label="$t('item.reason')" v-model="ItemData.ReasonId" :items="LoadReason.ReasonOption"
              :placeholder="$t('item.selectreason')" :rules="{ required: showFields.Reason?.require }"
              :required-icon="showFields.Reason?.require" name="Reason" id="Reason"
              @update:modelValue="ReasonOnchange" />
          </div>
        </b-col>
        <b-col lg="4" md="3" sm="6" cols="8">
          <div class="field">
            <Textarea v-model="ItemData.Description" :requiredIcon="false" placeholder=" " name="Description"
              id="Description" :label="$t('item.description')" :rules="{ required: false }" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="4" cols="12" v-if="showFields.promoqty?.show">
          <div class="field">
            <label path="Branch">{{ $t("item.promo") }}</label>
            <div class="d-flex flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <RadioButton v-model="ItemData.IsFreeItem" inputId="ingredient3" name="Yes" value="1"
                  @change="onIsFreeItemChange" />
                <label for="ingredient3" class="radio-label">{{
                  $t("5000.yes")
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton v-model="ItemData.IsFreeItem" inputId="ingredient4" name="No" value="0" />
                <label for="ingredient4" class="radio-label">{{
                  $t("5000.no")
                }}</label>
              </div>
            </div>
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="4" cols="12" v-if="showFields.IsFreeQty?.show">
          <div class="field">
            <label path="Branch">{{ $t("item.IsFreeItem") }}</label>
            <div class="d-flex flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <RadioButton v-model="ItemData.IsFreeQtyItem" inputId="ingredient3" name="Yes" value="1"
                  @change="onIsFreeQtyItemChange" />
                <label for="ingredient3" class="radio-label">{{
                  $t("5000.yes")
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton v-model="ItemData.IsFreeQtyItem" inputId="ingredient4" name="No" value="0" />
                <label for="ingredient4" class="radio-label">{{
                  $t("5000.no")
                }}</label>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="" v-if="showFields.ExcelImport?.show"> </b-col>
        <b-col class="d-flex flex-row-reverse pb-2">
          <Footer @cancel="IsFooterClear(0)" :cancelhide="true" :label="updatename" :loading="AddBtnLoader"
            CancelLabel="Clear" type="submit" />
        </b-col>
      </b-row>
    </b-form>
    <Dialog :modal="true" v-model:visible="ItemInfoPop" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '65vw' }" header="Item Info" @after-hide="ItemInfoPop = false">
      <Tableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
        :columns="ItemInfoHeaders" v-model:value="supplierDetailsList" :selectionMode="false">
        <template v-slot:Add>
          <span>
            <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
          </span>
        </template>
        <template v-slot:StockInHand="{ data }">
          {{ data.StockInHand - (data.PickedQty + data.InTransist) }}
        </template>
        <template v-slot:Brandmodelsize="{ data }">
          <span>
            <template v-if="
              data.BrandName != null &&
              data.ModelNumberName != null &&
              data.SizeName != null
            ">{{
              data.BrandName +
              "/" +
              data.ModelNumberName +
              "/" +
              data.SizeName
            }}</template>
            <template v-else-if="data.BrandName != null && data.ModelNumberName != null">{{ data.BrandName + "/" +
              data.ModelNumberName }}</template>
            <template v-else-if="data.BrandName != null">{{
              data.BrandName
            }}</template>
            <template v-else>{{ "-" }}</template>
          </span>
        </template>
      </Tableview>
    </Dialog>

    <Dialog :modal="true" v-model:visible="ItemLastTranspopup" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '65vw' }" header="Item Info" @after-hide="ItemLastTranspopup = false">
      <Tableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
        :columns="ItemLastTransInfoHeaders" v-model:value="LastTrasactionDetails" :selectionMode="false">
        <template v-slot:Add>
          <span>
            <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
          </span>
        </template>
        <template v-slot:StockInHand="{ data }">
          {{ data.StockInHand - (data.PickedQty + data.InTransist) }}
        </template>
        <template v-slot:Brandmodelsize="{ data }">
          <span>
            <template v-if="
              data.BrandName != null &&
              data.ModelNumberName != null &&
              data.SizeName != null
            ">{{
              data.BrandName +
              "/" +
              data.ModelNumberName +
              "/" +
              data.SizeName
            }}</template>
            <template v-else-if="data.BrandName != null && data.ModelNumberName != null">{{ data.BrandName + "/" +
              data.ModelNumberName }}</template>
            <template v-else-if="data.BrandName != null">{{
              data.BrandName
            }}</template>
            <template v-else>{{ "-" }}</template>
          </span>
        </template>
      </Tableview>
    </Dialog>
    <EditConfirmation :Editmodel="Editmodel" @yes="QuantityDataChange" @no="(Editmodel = false), IsClear"
      content="Item already added, Do you want to add more Quantity ?" />
    <EditConfirmation :Editmodel="EditmodelQty" @yes="AddItemsQty" @no="(EditmodelQty = false), IsClear"
      content="The Requested Quantity Is Exits,Do You Want To Issue More Quantity?" />
    <WarningMessage :visible="wariningPopup" :content="warningmsgcontent.warningcontent" @ok="() => {
        ItemData.ItemQuantity = '0';
        wariningPopup = false;
      }
      " />
    <Toast />
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  onUnmounted,
  computed,
  watch,
  PropType,
} from "vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import DropdownCustom from "../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import AddButton from "../../../../components/GeneralButtons/AddButton.vue";
import Loader from "../../../../components/FormComponents/Loader.vue";
import Tableview from "../../../../components/FormComponents/NormalTable.vue";

import Itemservice from "../../Service/ItemMasService";
import CommonService from "../../Service/CommonService";
import StockInService from "../../Service/StockInService";
import ItemCategoryservice from "../../Service/CategoryService";
import PackSizeService from "../../Service/PackSizeService";
import UnitMasterService from "../../Service/UnitMasService";
import ItemConfigurationService from "../../Service/ItemConfiguration";
import ItemCategoryMappingService from "../../Service/ItemCategoryMappingService";
import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import WarningMessage from "../../../../components/FormComponents/WarningMessage.vue";
import AutoCompleteCustom from "../../../../components/FormComponents/AutoComplete.vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import { useForm, useField } from "vee-validate";
import { useI18n } from "vue-i18n";
import { value } from "dom7";
// import Datepicker from '@/components/FormComponents/DatePicker.vue'
import { useToast } from "primevue/usetoast";
import moment from "moment";
import Textarea from "../../../../components/FormComponents/TextArea.vue";
import { useRoute, useRouter } from "vue-router";
import roomService from "../../Service/RoomService";
import RowService from "../../Service/RowService";
import RackService from "../../Service/RackService";
import ItemStoreMappingService from "../../Service/ItemStoreMappingService";
import ExportImport from "../../../../components/FormComponents/ExcelFileImport.vue";
import WithoutStockAffectService from "../../Service/WithoutStockAffectService";
import BoxService from "../../Service/BoxService";
import ReasonService from "../../Service/StockReasonService";

import { number } from "yup";
import UnitConversion from "../../pages/Masters/Items/UnitCoversionMaster/UnitConversionTable.vue";

interface FilterDataItem {
  ItemId: number;
  ItemQuantity: number;
}
export default defineComponent({
  components: {
    TextField,
    DropdownCustom,
    Datepicker,
    EditConfirmation,
    WarningMessage,
    AutoCompleteCustom,
    Footer,
    Textarea,
    ExportImport,
    Loader,
    Tableview,
  },

  props: {
    showone: {
      type: String,
      default: "",
    },
    AddListValues: {
      type: Array,
      default: "",
    },
    showFields: {
      type: Object,
      default: "false",
    },
    value: {},
    dataItems: {
      type: Object,
      default: {},
    },
    addItemData: {
      type: Array,
      default: [],
    },
    isFilterData: {
      type: Array as PropType<FilterDataItem[]>,
      default: [],
    },
    nonFilterData: {
      type: Array as PropType<FilterDataItem[]>,
      default: [],
    },
    commonItemProps: {
      type: Object,
      default: {},
    },
    requestdata: {
      type: Array,
      default: [],
    },
    consumeOrService: {
      type: String,
      default: "2",
    },
    changeval: {
      type: Number,
      default: 0,
    },
    LasTTransactionDocType: {
      type: String,
      default: "",
    },
    SelectedDCType: {
      type: Number,
      default: 0,
    },
  },

  setup(props, { emit }) {
    const toast = useToast();
    const Editmodel = ref(false);
    const { t } = useI18n();
    let updatename = ref("Add");
    let AddBtnLoader = ref(false);
    const EditmodelQty = ref(false);
    let warningmsgcontent = ref({ warningcontent: "" });
    const wariningPopup = ref(false);
    let AddData: any = ref([]);
    let itemDisabled = ref(false);
    let itemConfigDisabled = ref(false);
    let EditId = 0;
    let CurrentUOM: any = "";

    let ItemLastTransicon = ref(false);
    let ItemLastTranspopup = ref(false);
    let LastTrasactionDetails = ref([]);

    let dataItems: any = computed(() => props.dataItems);
    const { handleSubmit, errors, resetForm, resetField, setFieldError } =
      useForm();
    const FieldDisabled = ref({
      Batch: false,
      ExpiryDate: false,
      ManufactureDt: false,
    });
    const route = useRoute();
    let storebranchmapid = 0;
    let FromStoreBranchId = 0;

    if (route.query.data) {
      let QueryStringValue2: any = route.query;
      QueryStringValue2 = JSON.parse(QueryStringValue2.data);
      storebranchmapid =
        QueryStringValue2["storebranchmapid"] == null || ""
          ? QueryStringValue2["StoreBrMapId"] == null || ""
            ? 0
            : QueryStringValue2["StoreBrMapId"]
          : QueryStringValue2["storebranchmapid"];
      FromStoreBranchId =
        QueryStringValue2["BranchId"] == null || ""
          ? 0
          : QueryStringValue2["BranchId"];
    } else {
      storebranchmapid =
        route.query.storebranchmapid == null || ""
          ? 0
          : Number(route.query.storebranchmapid);
      FromStoreBranchId =
        route.query.BranchId == null || "" ? 0 : Number(route.query.BranchId);
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let labelQuantity =
      props.commonItemProps.fieldType == 1
        ? "Issued Quantity"
        : "Requested Quantity";
    watch(
      () => props.dataItems,
      (newVal) => {
        debugger;
        if (newVal["IsEdit"] == 1) {
          IsEdit(newVal);
          updatename.value = "Update";
          ItemInfoIcon.value = true;
          if (props.LasTTransactionDocType) {
            ItemLastTransicon.value = true;
          }
        }
      }
    );

    watch(
      () => props.changeval == 2,
      (newVal) => {
        debugger;
        AddData.value = props.addItemData;
        AddData.value.map((item) => {
          item.defaultunitrate = item.UnitRate;
          item.defaultQty = item.ItemQuantity;
          item.defaultpacksize = item.PackSizeId;
          //item.defaultStockIn = Number(item.StockInHand) //commented by tharuni for Issue edit issue. when edit stock in and already added item qty added in next line
          item.defaultStockIn =
            Number(item.StockInHand) + Number(item.defaultQty);
          // item.ItemId = item.Id
        });
        if (props.addItemData.length > 0) {
          Object.keys(ItemDataTotalValue).forEach((key) => {
            if (AddData.value[0][key])
              ItemDataTotalValue[key] = AddData.value[0][key];
          });
        }

        //emit("calculation", ItemDataTotalValue);
        emit("taxcalculation", AddData.value);
      }
    );

    watch(
      () => props.addItemData,
      (newVal) => {
        debugger;
        AddData.value = newVal;
        AddData.value.map((item) => {
          item.defaultunitrate = item.UnitRate;
          item.defaultQty = item.ItemQuantity;
          item.defaultpacksize = item.PackSizeId;
          item.defaultStockIn =
            Number(item.StockInHand) + Number(item.defaultQty);
        });
        if (newVal.length > 0) {
          Object.keys(ItemDataTotalValue).forEach((key) => {
            if (AddData.value[0][key])
              ItemDataTotalValue[key] = AddData.value[0][key];
          });
        }
        emit("taxcalculation", AddData.value);
      },
      { deep: true }
    );

    watch(props, (newValue) => {
      debugger;
      if (newValue.isFilterData.length > 0) {
        // ItemCheck()
        LoadItem();
      }
      //LoadItem();
    });

    watch(
      () => props.requestdata,
      (newVal) => {
        debugger;
        //AddData.value.push(props.requestdata);

        AddData.value = newVal;
      }
    );

    const BatchNoFlag = ref(false);

    function onKeyUp(event: KeyboardEvent) {
      debugger;
      if (event.altKey && event.key == "s") {
        IsSubmit();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true
      ) {
        if (!BatchNoFlag.value) {
          QuantityDataChange();
        } else {
          BatchNoFlag.value = false;
        }
      } else if (event.key == "n" && Editmodel.value == true) {
        Editmodel.value = false;
        BatchNoFlag.value = false;
        IsClear();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        EditmodelQty.value == true
      ) {
        AddItemsQty();
      } else if (event.key == "n" && EditmodelQty.value == true) {
        EditmodelQty.value = false;
        IsClear();
      }
    }
    debugger;
    let ItemFields = ref({
      BatchRequired: false,
      ExpiryDtRequired: false,
      NoMrp: false,
      // ManufactureDate: false,
      ManufactureDtRequired: false,
    });

    let ItemData = reactive({
      ItemCategory: "",
      Itemname: "",
      BatchNo: "",
      PackSizename: "",
      UnitRate: "0.00",
      ItemQuantity: "",
      ItemChkQuantity: "",
      ItemQuantityInHand: "",
      MRP: "0.00",
      Discount: "0.0",
      ItemId: 0,
      IsEdit: 0,
      CategoryLableName: "",
      CategoryId: 0,
      PackSizename1: "",
      PackSizeId: ref(),
      PackSizeQty: 0,
      UOM: ref(),
      UOMName: "",
      Brand: ref(),
      BrandName: "",
      ModelNumber: ref(),
      ModelNumberName: "",
      Size: ref(),
      SizeName: "",
      Itemname1: "",
      // Itemid: 0,
      ReOrderLevel: 0,
      HSNId: 0,
      ItemCode: "",
      HSNCode: "",
      SalesUnit: 0,
      SalesUnitName: "",
      PurchaseUnitName: "",
      SalesPrice: 0,
      PurchasePrice: 0,

      grossamount: 0.0,
      taxamount: 0.0,
      DiscountAmount: 0.0,
      transportcharges: "0.0",
      servicecharges: "0.0",
      othercharges: "0.0",
      totaltransportcharges: 0.0,
      totalservicecharges: 0.0,
      totalothercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
      totalrate: 0.0,
      totaldiscountamount: 0.0,
      Totalvalue: 0.0,

      Purchasetaxamount: "0.00",
      PurchasePercentage: 0,

      SalesPercentage: 0,
      Salestaxamount: 0.0,

      SGSTTax: 0,
      SGSTTaxAmount: "0.00",
      CGSTTax: 0,
      CGSTTaxAmount: "0.00",
      IGSTTax: 0,
      IGSTTaxAmount: "0.00",
      Amount: " 0.00",

      Rate: "0.00",
      PurchaseUnit: 0,
      StockInHand: "0",
      IssuedQty: "0",
      FromDate: "",
      ToDate: "",
      ExpiryDate: "",
      //
      RequestedQty: "0",
      BarCodeNo: "0",
      BarCode: "",
      RateContractCount: 0,
      PurchaseType: 0,
      SalesType: 0,
      Description: "",
      POSupplierId: 0,
      POSupplierName: "",
      IsContractStatus: ref(),
      ItemProductId: "",
      StockInId: 0,
      StockInDetailId: 0,
      IsConsigneeItem: 0,
      SupplierId: 0,
      OrgItemsQty: 0,
      ColdChain: "",
      DocNo: "",
      GRNId: 0,
      ReasonId: ref(),
      IssueId: ref(),
      ReasonName: "",
      RoomId: ref(),
      RackId: ref(),
      RowId: ref(),
      BoxId: ref(),
      RoomName: "",
      RackName: "",
      RowName: "",
      BoxName: "",
      ManufactureDate: ref(),
      IsFreeItem: "0",
      HSNManulCode: "",
      GrnAvlQty: "0",
      Discountamount: 0.0,
      GrnAvlQty1: "0",
      PickedQty: 0,
      InTransist: 0,
      ConversionFactor: 1,
      Asset: 0,
      ReceivedQty: 0,
      GRNRecQty: 0,
      IsFreeQtyItem: "0",
      IsBrand: false,
      IsModel: false,
      IsSize: false,
      SupplierBarCode: "",
      BatchChecked: false,
      SupplierChecked: false,
      IssueNo: "",
      IssueDate: "",
      ReturnedQty: 0,
      //
    });

    // watch(
    //   [() => ItemData.SupplierChecked, () => ItemData.BatchNo],
    //   ([supplierChecked, batchNo]) => {
    //     ItemData.SupplierBarCode = supplierChecked ? batchNo : "";
    //   }
    // );

    function BatchNokeyup() {
      debugger;

      if (ItemData.SupplierChecked) {
        ItemData.SupplierBarCode = ItemData.BatchNo;
      } else {
        ItemData.SupplierBarCode = "";
      }
    }

    function SupplierCheckedOnChange() {
      debugger;
      if (ItemData.SupplierChecked) {
        ItemData.SupplierBarCode = ItemData.BatchNo;
      } else {
        ItemData.SupplierBarCode = "";
      }
    }

    let ItemDataTotalValue = reactive({
      totaltaxamount: 0.0,
      totaldiscountamount: 0.0,
      totalgrossamount: 0.0,
      totaltransportcharges: 0.0,
      totalservicecharges: 0.0,
      totalothercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
      totalrate: 0.0,
      grossamount: 0.0,
    });
    let ItemQuantity = 0.0;
    let POFlag = ref(props.commonItemProps?.POFlag || 0);
    let UnitRateZero = ref(props.commonItemProps?.UnitRateZero || 0);
    let ItemInfoIcon = ref(false);
    const ItemInfoPop: any = ref(false);
    let loading = ref(false);

    onMounted(() => {
      debugger;
      Object.assign(ItemData, props.value);
      document.addEventListener("keyup", onKeyUp);
      update();
      // PackSize();
      UOM();
      LoadItemConfigurations();
      ClipBoarData();
      // LoadBox();
      // LoadRoom();
      // LoadRow();
      // LoadRack();
      LoadReasons();
    });

    // Copy and Past Clipboard
    function ClipBoarData() {
      debugger;
      document.addEventListener("paste", handlePaste);
    }

    onUnmounted(() => {
      debugger;
      document.removeEventListener("paste", handlePaste);
    });

    const handlePaste = async (event: ClipboardEvent) => {
      debugger;

      // Get the pasted data from the clipboard
      const clipboardData = event.clipboardData;
      const pastedText = clipboardData?.getData("text");
      console.log("Pasted text:", pastedText);
      await LoadItem();
      if (LoadItemName.value.ITEMoption.length > 0) {
        let ItemValueHidden: any = ref({});
        let ItemValue = LoadItemName.value.ITEMoption.filter(
          (x) => x.BarCodeNo == pastedText
        );
        ItemValueHidden.value = ItemValue[0];
        ItemOnChange(ItemValueHidden);
      }
    };

    function update() {
      debugger;
      emit("update:modelValue", ItemData);
    }

    // const LoadReason = ref({
    //   ReasonOption: [
    //     { name: "Expired", value: 1 },
    //     { name: "Damage", value: 2 },
    //     { name: "Non moveable", value: 3 },
    //   ],
    // });

    const ReasonOnchange = (ReasonId) => {
      debugger;
      if (ReasonId) {
        let options: any = LoadReason.value.ReasonOption.find(
          (item) => item["value"] == ReasonId
        );

        ItemData.ReasonName = options["name"];
      }
    };
    async function DocNoOnchange(DocId) {
      debugger;
      if (DocId) {
        await getValues(
          ItemData.ItemId,
          ItemData.BarCodeNo,
          StockInHandObj.value.BrandId,
          StockInHandObj.value.ModelNumberId,
          StockInHandObj.value.SizeId,
          1, //Restrict Brand, Model and size Onchanges calling function for loop,
          DocId
        );
      }
    }

    const LoadReason = ref({
      ReasonOption: [],
    });
    const LoadIssueNo = ref({
      IssueNoOption: [],
    });

    async function LoadReasons() {
      debugger;
      try {
        const response = await ReasonService.getlistdata();

        LoadReason.value.ReasonOption = response["result"]
          .filter((x) => x.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.name = item.ReasonName;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    //Category On Change
    const LoadItemName: any = ref({
      ITEMid: null,
      ITEMoption: [],
    });

    const ItemInfoHeaders = [
      {
        header: t("storetabdetails.pocreationtable.SupplierName"),
        field: "POSupplierName",
        class: "smallwidth",
      },
      {
        header: "Branch",
        field: "BranchName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.Store"),
        field: "StoreName",
        class: "smallwidth",
      },
      {
        header: "Brand/model/size",
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.pocreationtable.Qty"),
        field: "POQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.UnitRate"),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.Rate"),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Avl Qty",
        slot: "StockInHand",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.PickedQty"),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.InTransist"),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "ReorderLevel",
        field: "ReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
    ];

    const ItemLastTransInfoHeaders = [
      {
        header: t("storetabdetails.LastTransDetail.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.LastTransDetail.prdocno"),
        field: "DocNo",
        bodyclass: "boldclass",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.LastTransDetail.tostorename"),
        field: "ToStoreName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.LastTransDetail.itemname"),
        field: "ItemName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.LastTransDetail.qty"),
        field: "Qty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.LastTransDetail.brandname"),
        field: "BrandName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.LastTransDetail.modelname"),
        field: "ModelNumberName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.LastTransDetail.sizename"),
        field: "SizeName",
        class: "smallwidth",
      },
    ];

    //Item Edit
    async function IsEdit(data) {
      debugger;

      await IsFooterClear(1);

      itemDisabled.value = true;
      itemConfigDisabled.value = true;
      Object.keys(ItemFields.value).forEach((key) => {
        if (data[key]) ItemFields.value[key] = data[key];
      });

      Object.keys(ItemData).forEach((key) => {
        if (data[key] && key != "StockInHand") ItemData[key] = data[key];
        else if (key == "StockInHand")
          ItemData.StockInHand =
            data["defaultStockIn"] &&
              data["IsRequest"] != 1 &&
              data["IsRequest"] != undefined
              ? data["defaultStockIn"]
              : data["StockInHand"];
      });
      ItemData.ExpiryDate = await data["ExpiryDate"];
      ItemData.ManufactureDate =
        (await data["ManufactureDate"]) == "Invalid date"
          ? null
          : data["ManufactureDate"];
      //ItemData.GrnAvlQty = await data["StockInHand"];
      ItemDataTotalValue.totalothercharges = Math.max(
        ItemDataTotalValue.totalothercharges -
        parseFloat(ItemData.othercharges),
        0
      );
      ItemDataTotalValue.totalservicecharges = Math.max(
        ItemDataTotalValue.totalservicecharges -
        parseFloat(ItemData.servicecharges),
        0
      );
      ItemDataTotalValue.totaltransportcharges = Math.max(
        ItemDataTotalValue.totaltransportcharges -
        parseFloat(ItemData.transportcharges),
        0
      );
      ItemDataTotalValue.grossamount = Math.max(
        ItemDataTotalValue.grossamount - Number(ItemData.Rate),
        0
      );
      ItemDataTotalValue.totaltaxamount = Math.max(
        ItemDataTotalValue.totaltaxamount - Number(ItemData.Purchasetaxamount),
        0
      );
      ItemDataTotalValue.totaldiscountamount = Math.max(
        ItemDataTotalValue.totaldiscountamount - ItemData.DiscountAmount,
        0
      );
      ItemDataTotalValue.totalqty = Math.max(
        ItemDataTotalValue.totalqty - Number(ItemData.ItemQuantity),
        0
      );

      debugger;
      if (props.commonItemProps?.GRNReturnFlag) {
        if (data["PurchaseUnit"] == data["UOM"]) {
          CurrentUOM = "PurchaseUnit";
        } else if (data["SalesUnit"] == data["UOM"]) {
          CurrentUOM = "SalesUnit";
        }
        LoadUOM.value.UOMoption = LoadUOM.value.DuplicateUOMoption.filter(
          (items: any) =>
            items.Id == data["PurchaseUnit"] || items.Id == data["SalesUnit"]
        );
      }
    }

    async function IsUpdate() {
      debugger;
      if (props.commonItemProps.type == 1) {
        if (
          Number(ItemData.StockInHand) < Number(ItemData.ItemQuantity) &&
          props.commonItemProps.fieldType != 1
        ) {
          warningmsgcontent.value.warningcontent =
            "You Don't Have Qty In Your Store";
          wariningPopup.value = true;
        } else if (
          Number(ItemData.GrnAvlQty) < Number(ItemData.ItemQuantity) &&
          props.commonItemProps.fieldType == 1 &&
          props.showFields.GrnAvlQty?.show
        ) {
          warningmsgcontent.value.warningcontent =
            "You Don't Have Qty In Your Store";
          wariningPopup.value = true;
        } else if (
          ItemData.IssuedQty < ItemData.ItemQuantity &&
          props.commonItemProps.fieldType == 1 &&
          props.showFields.GrnAvlQty?.show == false
        ) {
          warningmsgcontent.value.warningcontent =
            "You Don't Have Qty In Your Store";
          wariningPopup.value = true;
        } else {
          await EditItems();
        }
      } else {
        await EditItems();
      }

      updatename.value = "Add";

      toast.add({
        severity: "success",
        summary: "Successful",
        detail: "The item has been updated successfully.",
        life: 3000,
      });
    }

    async function EditItems() {
      debugger;
      let Id = 0;
      let idChk = "";
      if (
        props.commonItemProps.itemType == 1 ||
        (props.commonItemProps.itemType == 3 &&
          ItemData.BarCodeNo &&
          ItemData.BarCodeNo != "0")
      ) {
        Id = Number(ItemData.BarCodeNo);
        idChk = "BarCodeNo";
      } else {
        Id = ItemData.ItemId;
        idChk = "ItemId";
      }

      Object.values(AddData.value).forEach((items: any) => {
        if (props.commonItemProps?.IsFilter == 3) {
          if (ItemData.IsEdit != 0) {
            if (
              (items["" + idChk + ""] == Id && idChk == "BarCodeNo") ||
              (items["" + idChk + ""] == Id &&
                idChk == "ItemId" &&
                items.BatchNo == (ItemData.BatchNo || "") &&
                items.ModelNumber == (ItemData.ModelNumber || 0) &&
                items.Size == (ItemData.Size || 0) &&
                items.Brand == (ItemData.Brand || 0) &&
                items.IsFreeItem == (ItemData.IsFreeItem || "0") &&
                items.IsFreeQtyItem == (ItemData.IsFreeQtyItem || "0"))
              // &&
              // items.SupplierBarCode == (ItemData.SupplierBarCode || "")
            ) {
              Object.keys(items).forEach((key) => {
                if (ItemData[key] != undefined && ItemData[key] != null) {
                  if (
                    key == "FromDate" ||
                    key == "ToDate" ||
                    key == "ExpiryDate" ||
                    key == "ManufactureDate"
                  ) {
                    const regex = /^\d{2}-\d{2}-\d{4}$/;

                    let format = regex.test(ItemData[key])
                      ? ItemData[key]
                      : moment(ItemData[key]).format("DD-MM-YYYY");
                    items[key] = format == "Invalid date" ? "" : format;
                  } else {
                    items[key] =
                      ItemData[key] == "Invalid date" ? "" : ItemData[key];
                  }
                }
              });
            }
          } else {
            if (
              (items["" + idChk + ""] == Id && idChk == "BarCodeNo") ||
              (items["" + idChk + ""] == Id &&
                idChk == "ItemId" &&
                items.BatchNo == (ItemData.BatchNo || "") &&
                items.ModelNumber == (ItemData.ModelNumber || 0) &&
                items.Size == (ItemData.Size || 0) &&
                items.Brand == (ItemData.Brand || 0) &&
                items.IsFreeItem == (ItemData.IsFreeItem || "0") &&
                items.IsFreeQtyItem == (ItemData.IsFreeQtyItem || "0"))
              // &&
              // items.SupplierBarCode == (ItemData.SupplierBarCode || "")
            ) {
              Object.keys(items).forEach((key) => {
                if (ItemData[key] != undefined && ItemData[key] != null) {
                  if (
                    key == "FromDate" ||
                    key == "ToDate" ||
                    key == "ExpiryDate" ||
                    key == "ManufactureDate"
                  ) {
                    const regex = /^\d{2}-\d{2}-\d{4}$/;

                    let format = regex.test(ItemData[key])
                      ? ItemData[key]
                      : moment(ItemData[key]).format("DD-MM-YYYY");
                    items[key] = format == "Invalid date" ? "" : format;
                  } else {
                    items[key] =
                      ItemData[key] == "Invalid date" ? "" : ItemData[key];
                  }
                }
              });
            }
          }
        } else {
          if (
            (items["" + idChk + ""] == Id && idChk == "BarCodeNo") ||
            (items["" + idChk + ""] == Id &&
              idChk == "ItemId" &&
              items.ModelNumber == (ItemData.ModelNumber || 0) &&
              items.Size == (ItemData.Size || 0) &&
              items.Brand == (ItemData.Brand || 0))
          ) {
            Object.keys(items).forEach((key) => {
              if (ItemData[key] != undefined && ItemData[key] != null) {
                if (
                  key == "FromDate" ||
                  key == "ToDate" ||
                  key == "ExpiryDate" ||
                  key == "ManufactureDate"
                ) {
                  const regex = /^\d{2}-\d{2}-\d{4}$/;

                  let format = regex.test(ItemData[key])
                    ? ItemData[key]
                    : moment(ItemData[key]).format("DD-MM-YYYY");
                  items[key] = format == "Invalid date" ? "" : format;
                } else {
                  items[key] =
                    ItemData[key] == "Invalid date" ? "" : ItemData[key];
                }
              }
            });
          }
        }
      });

      await IsClear();

      await LoadItemConfigurations();
      await emit("taxcalculation", AddData.value);
      await emit("update:dataItems", {});
      emit("ItemUpdated", true);
    }

    async function CategoryOnChange(CId) {
      debugger;
      if (CId) {
        let options: any = LoadCategoryName.value.Categoryoption.find(
          (item) => item["value"] == CId
        );
        ItemData.CategoryLableName = options["name"];
        ItemData.CategoryId = CId;
        try {
          const dataresponse = await ItemCategoryMappingService.getItemdata(
            props.commonItemProps.storeId,
            CId
          );

          console.log(dataresponse);
          debugger;
          if (props.isFilterData.length != 0) {
            LoadItemName.value.ITEMoption = dataresponse["result"]
              .map((item: any) => {
                item.name = item.Name;
                item.value = item.ItemId;
                item.extraValue = item.ItemQuantity; // Set the extraValue attribute to ItemQuantity
                return item;
              })
              .filter((item) => {
                const data = props.isFilterData.find(
                  (data: any) => data.ItemId === item.value
                );
                if (data && data.ItemQuantity !== undefined) {
                  item.extraValue = data.ItemQuantity; // Set the extraValue attribute to the ItemQuantity property of the matching item in props.isFilterData
                }
                return data != null; // Filter the items based on whether they have a matching ItemId in the props.isFilterData array
              });
          } else {
            LoadItemName.value.ITEMoption = dataresponse["result"].map(
              (item: any) => {
                item.name = item.Name;
                item.value = item.ItemId;
                return item;
              }
            );
          }
        } catch (error) {
          console.log(error);
        }
      }
    }

    // Load category
    const LoadCategoryName = ref({
      Categoryid: null,
      Categoryoption: [],
    });

    function ItemCheck() {
      LoadItem();
    }

    async function LoadItem() {
      try {
        debugger;
        let FromStoreId = props.commonItemProps.storeId;
        let ToStoreId = props.commonItemProps?.tostoreId;
        let Type = props.commonItemProps?.itemType ?? 0;
        let requestType = props.commonItemProps?.requestType ?? 0;
        let barcodeType = props.commonItemProps?.barcodeType ?? 0; // added by tharuni for grn return need to check other scenario and need to  remove this
        let SupplierId = props.commonItemProps?.supplierId ?? 0;

        if (FromStoreId != 0 && FromStoreId != "" && ItemData.Itemname1) {
          const dataresponse = await Itemservice.GetItemByStoresId(
            FromStoreId,
            ToStoreId,
            ItemData.Itemname1,
            Type,
            SupplierId,
            storebranchmapid,
            props.commonItemProps.ToStoreBrMapId == null || ""
              ? 0
              : props.commonItemProps.ToStoreBrMapId,
            usersData.OrganizationId
          );

          let idChk = "",
            valueChk = "",
            itemChk = "";
          if (requestType == 1 && Type == 1 && barcodeType == 0) {
            (idChk = "Id"), (valueChk = "BarCodeNo");
            itemChk = "ItemId";
          } else if (
            Type == 1 ||
            (requestType == 1 && Type == 1 && barcodeType == 1)
          ) {
            idChk = "BarCodeNo";
            valueChk = "BarCodeNo";
            itemChk = "BarCodeNo";
          } else {
            idChk = "Id";
            valueChk = "Id";
            itemChk = "ItemId";
          }
          let SearchText = ItemData.Itemname1;
          let regex = new RegExp(SearchText, "i");

          if (props.commonItemProps?.IsFilter == 1) {
            if (props.isFilterData.length != 0) {
              LoadItemName.value.ITEMoption = dataresponse["result"]
                .filter(
                  (x) =>
                    (regex.test(x.Name) || regex.test(x.ProductId)) &&
                    x.IsBlock != 1
                )
                .map((item: any) => {
                  item.label =
                    item.Name +
                    " |" +
                    " Qty: " +
                    item.StockInHand +
                    " |" +
                    "Stock Value:" +
                    item.TotalValue;
                  item.value = item["" + valueChk + ""];
                  item.extraValue = item.ItemQuantity; // Set the extraValue attribute to ItemQuantity
                  if (Type == 0) {
                    item.BarCodeNo = 0;
                  }
                  return item;
                })
                .filter((item) => {
                  const data = props.isFilterData.find(
                    (data: any) =>
                      data["" + itemChk + ""] == item["" + idChk + ""]
                  );
                  if (data && data.ItemQuantity !== undefined) {
                    item.extraValue = data.ItemQuantity; // Set the extraValue attribute to the ItemQuantity property of the matching item in props.isFilterData
                  }
                  return data != null; // Filter the items based on whether they have a matching ItemId in the props.isFilterData array
                });
            } else {
              LoadItemName.value.ITEMoption = [];
            }
          } else if (props.commonItemProps?.IsFilter == 2) {
            if (props.isFilterData.length != 0) {
              LoadItemName.value.ITEMoption = dataresponse["result"]
                .filter((x) => regex.test(x.Name) || regex.test(x.ProductId))
                .map((item: any) => {
                  let expiryLabel =
                    item.ExpiryDate === "01-01-0001" ||
                      item.ExpiryDate === "01-01-1900"
                      ? ""
                      : " (Exp. Date: " + item.ExpiryDate + ")";

                  item.label = item.Name + expiryLabel;
                  item.value = item["" + valueChk + ""];
                  item.extraValue = item.ItemQuantity;

                  return item;
                })
                .filter((item) => {
                  const data = props.isFilterData.find(
                    (data: any) =>
                      data["" + itemChk + ""] == item["" + idChk + ""]
                  );
                  if (data && data.ItemQuantity !== undefined) {
                    item.extraValue = data.ItemQuantity; // Set the extraValue attribute to the ItemQuantity property of the matching item in props.isFilterData
                  }
                  return data != null; // Filter the items based on whether they have a matching ItemId in the props.isFilterData array
                });
            } else {
              LoadItemName.value.ITEMoption = [];
            }
          } else {
            if (props.isFilterData.length != 0) {
              LoadItemName.value.ITEMoption = dataresponse["result"]
                .filter(
                  (x) =>
                    (regex.test(x.Name) || regex.test(x.ProductId)) &&
                    x.IsBlock != 1
                )
                .map((item: any) => {
                  item.label =
                    item.Name +
                    " |" +
                    " Qty: " +
                    item.StockInHand +
                    " |" +
                    "Stock Value:" +
                    item.TotalValue;
                  item.value = item["" + valueChk + ""];
                  item.extraValue = item.ItemQuantity; // Set the extraValue attribute to ItemQuantity
                  if (Type == 0) {
                    item.BarCodeNo = 0;
                  }
                  return item;
                })
                .filter((item) => {
                  const data = props.isFilterData.find(
                    (data: any) =>
                      data["" + itemChk + ""] == item["" + idChk + ""]
                  );
                  if (data && data.ItemQuantity !== undefined) {
                    item.extraValue = data.ItemQuantity; // Set the extraValue attribute to the ItemQuantity property of the matching item in props.isFilterData
                  }
                  return data != null; // Filter the items based on whether they have a matching ItemId in the props.isFilterData array
                });
            } else {
              if (
                props.nonFilterData.length != 0 &&
                props.commonItemProps?.GRNFlag != true
              ) {
                dataresponse["result"] = dataresponse["result"].filter(
                  (item) => {
                    const isNotPresent = !props.nonFilterData.some((data) => {
                      return data[itemChk] == item[idChk];
                    });
                    return isNotPresent;
                  }
                );
              }
              LoadItemName.value.ITEMoption = dataresponse["result"]
                .filter(
                  (x) =>
                    (regex.test(x.Name) || regex.test(x.ProductId)) &&
                    x.IsBlock != 1
                )
                .map((item: any) => {
                  item.label =
                    item.Name +
                    " |" +
                    " Qty: " +
                    item.StockInHand +
                    " |" +
                    "Stock Value:" +
                    item.TotalValue;
                  item.value = item["" + valueChk + ""];
                  if (Type == 0) {
                    item.BarCodeNo = 0;
                  }
                  return item;
                });
            }
          }
        }
      } catch (error) { }
    }

    async function loadBasedonConsumeOrService() {
      try {
        debugger;
        let FromStoreId = props.commonItemProps.storeId;
        let ToStoreId = props.commonItemProps?.tostoreId;
        let Type = props.commonItemProps?.itemType ?? 0;
        let requestType = props.commonItemProps?.requestType ?? 0;
        let barcodeType = props.commonItemProps?.barcodeType ?? 0; // added by tharuni for grn return need to check other scenario and need to  remove this
        let SupplierId = props.commonItemProps?.supplierId ?? 0;
        if (FromStoreId != 0 && FromStoreId != "") {
          const dataresponse = await Itemservice.GetItemByStoresId(
            FromStoreId,
            ToStoreId,
            ItemData.Itemname1,
            Type,
            SupplierId,
            storebranchmapid,
            props.commonItemProps.ToStoreBrMapId == null || ""
              ? 0
              : props.commonItemProps.ToStoreBrMapId,
            usersData.OrganizationId,
            0
          );
          let idChk = "",
            valueChk = "",
            itemChk = "";
          if (requestType == 1 && Type == 1 && barcodeType == 0) {
            (idChk = "Id"), (valueChk = "BarCodeNo");
            itemChk = "ItemId";
          } else if (
            Type == 1 ||
            (requestType == 1 && Type == 1 && barcodeType == 1)
          ) {
            idChk = "BarCodeNo";
            valueChk = "BarCodeNo";
            itemChk = "BarCodeNo";
          } else {
            idChk = "Id";
            valueChk = "Id";
            itemChk = "ItemId";
          }

          let SearchText = ItemData.Itemname1;
          let regex = new RegExp(SearchText, "i");

          if (Number(props.consumeOrService) == 1) {
            LoadItemName.value.ITEMoption = dataresponse["result"]
              .filter(
                (x) =>
                  (regex.test(x.Name) || regex.test(x.ProductId)) &&
                  x.IsBlock != 1
              )
              .map((item: any) => {
                item.label =
                  item.Name +
                  " |" +
                  " Qty: " +
                  item.StockInHand +
                  " |" +
                  "Stock Value:" +
                  item.TotalValue;
                item.value = item["" + valueChk + ""];
                if (Type == 0) {
                  item.BarCodeNo = 0;
                }
                return item;
              })
              .filter(
                (items) =>
                  items.ServiceLevel ==
                  (Number(props.consumeOrService) == 1 ? true : false)
              );
          } else if (Number(props.consumeOrService) == 0) {
            LoadItemName.value.ITEMoption = dataresponse["result"]
              .filter(
                (x) =>
                  (regex.test(x.Name) || regex.test(x.ProductId)) &&
                  x.IsBlock != 1
              )
              .map((item: any) => {
                item.label =
                  item.Name +
                  " |" +
                  " Qty: " +
                  item.StockInHand +
                  " |" +
                  "Stock Value:" +
                  item.TotalValue;
                item.value = item["" + valueChk + ""];
                if (Type == 0) {
                  item.BarCodeNo = 0;
                }
                return item;
              })
              .filter(
                (items) => items.ServiceLevel != true && items.Asset != true

                // items.AutoConsumed ==
                // (Number(props.consumeOrService) == 0 ? true : false)
              );
          } else if (Number(props.consumeOrService) == 3) {
            LoadItemName.value.ITEMoption = dataresponse["result"]
              .filter(
                (x) =>
                  (regex.test(x.Name) || regex.test(x.ProductId)) &&
                  x.IsBlock != 1
              )
              .map((item: any) => {
                item.label =
                  item.Name +
                  " |" +
                  " Qty: " +
                  item.StockInHand +
                  " |" +
                  "Stock Value:" +
                  item.TotalValue;
                item.value = item["" + valueChk + ""];
                if (Type == 0) {
                  item.BarCodeNo = 0;
                }
                return item;
              })
              .filter(
                (items) =>
                  items.Asset ==
                  (Number(props.consumeOrService) == 3 ? true : false)
              );
          } else if (Number(props.consumeOrService) == 4) {
            LoadItemName.value.ITEMoption = dataresponse["result"]
              .filter(
                (x) =>
                  (regex.test(x.Name) || regex.test(x.ProductId)) &&
                  x.IsBlock != 1
              )
              .map((item: any) => {
                item.label =
                  item.Name +
                  " |" +
                  " Qty: " +
                  item.StockInHand +
                  " |" +
                  "Stock Value:" +
                  item.TotalValue;
                item.value = item["" + valueChk + ""];
                if (Type == 0) {
                  item.BarCodeNo = 0;
                }
                return item;
              })
              .filter((items) => items.IsProduct == true);
          }
          else if (Number(props.consumeOrService) == 6) {
            LoadItemName.value.ITEMoption = dataresponse["result"]
              .filter(
                (x) =>
                  (regex.test(x.Name) || regex.test(x.ProductId)) &&
                  x.IsBlock != 1
              )
              .map((item: any) => {
                item.label =
                  item.Name +
                  " |" +
                  " Qty: " +
                  item.StockInHand +
                  " |" +
                  "Stock Value:" +
                  item.TotalValue;
                item.value = item["" + valueChk + ""];
                if (Type == 0) {
                  item.BarCodeNo = 0;
                }
                return item;
              })
              .filter((items) => items.IsWorkOrder == true);
          }
          else if (Number(props.consumeOrService) == 7) {
            LoadItemName.value.ITEMoption = dataresponse["result"]
              .filter(
                (x) =>
                  (regex.test(x.Name) || regex.test(x.ProductId)) &&
                  x.IsBlock != 1
              )
              .map((item: any) => {
                item.label =
                  item.Name +
                  " |" +
                  " Qty: " +
                  item.StockInHand +
                  " |" +
                  "Stock Value:" +
                  item.TotalValue;
                item.value = item["" + valueChk + ""];
                if (Type == 0) {
                  item.BarCodeNo = 0;
                }
                return item;
              })

          }
        }
      } catch (error) { }
    }

    async function ItemCategoryname() {
      debugger;
      let StoreID = "";
      StoreID = props.commonItemProps.storeId;
      if (!StoreID) {
        StoreID = JSON.parse(StoreID).StoreId;
      }
      try {
        const dataresponse = await ItemCategoryservice.GetCategory(StoreID);

        console.log(dataresponse);
        debugger;

        if (props.isFilterData.length != 0) {
          LoadCategoryName.value.Categoryoption = dataresponse["result"]
            .map((item: any) => {
              item.name = item.Name;
              item.value = item.ItemCategoryId;
              return item;
            })
            .filter((item) => {
              const data = props.isFilterData.find(
                (data: any) => data.CategoryId === item.ItemCategoryId
              );
              return data != null;
            });
        } else {
          LoadCategoryName.value.Categoryoption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.Name;
              item.value = item.ItemCategoryId;
              return item;
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    }

    // const LoadPackSize = ref({
    //   packagesizeoption: [],
    // });

    // Load Package Size
    // async function PackSize() {
    //   debugger;
    //   try {
    //     const dataresponse = await PackSizeService.getlistdata();

    //     console.log(dataresponse);
    //     debugger;

    //     LoadPackSize.value.packagesizeoption = dataresponse["result"]
    //       .filter((x) => x.HospitalId == usersData.OrganizationId)
    //       .map((item: any) => {
    //         item.name = item.Name;
    //         item.value = item.Id;
    //         return item;
    //       });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    // const PackageSizeOnChange = (PId) => {
    //   debugger;
    //   //ItemData.PackageSizeLableName = PId.originalEvent.currentTarget.ariaLabel;
    // if (PId) {
    //   let options: any = LoadPackSize.value.packagesizeoption.find(
    //     (item) => item["value"] == PId
    //   );
    //   ItemData.PackSizename1 = options["name"];
    //   ItemData.PackSizeId = PId;
    //   ItemData.PackSizeQty = options["Qty"];
    //   ItemData.IssuedQty =
    //     ItemData.OrgItemsQty && ItemData.OrgItemsQty != 0
    //       ? String(Number(ItemData.OrgItemsQty) / Number(options["Qty"]))
    //       : ItemData.IssuedQty;
    //   ItemData.RequestedQty =
    //     ItemData.OrgItemsQty && ItemData.OrgItemsQty != 0
    //       ? String(Number(ItemData.OrgItemsQty) / Number(options["Qty"]))
    //       : ItemData.RequestedQty;
    //   //  ItemData.GrnAvlQty = String(Number(ItemData.GrnAvlQty1))
    // }
    // };

    const LoadUOM = ref({
      UOMoption: [],
      DuplicateUOMoption: [],
    });

    // Load UOM
    async function UOM() {
      debugger;
      try {
        const dataresponse = await UnitMasterService.getdata();

        console.log(dataresponse);
        debugger;

        LoadUOM.value.UOMoption = dataresponse["result"]
          .filter((x) => x.HospitalId == usersData.OrganizationId)
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        LoadUOM.value.DuplicateUOMoption = JSON.parse(
          JSON.stringify(LoadUOM.value.UOMoption)
        );
      } catch (error) {
        console.log(error);
      }
    }

    const UOMOnChange = (UOMId) => {
      if (UOMId) {
        let options: any = LoadUOM.value.UOMoption.find(
          (item) => item["value"] == UOMId
        );
        ItemData.UOMName = options["Name"];
        ItemData.UOM = UOMId;
        debugger;
        if (ItemData.SalesUnit == UOMId && CurrentUOM == "PurchaseUnit") {
          ItemData.GRNRecQty =
            Number(ItemData.GRNRecQty) * Number(ItemData.ConversionFactor);
          ItemData.GrnAvlQty = String(
            Number(ItemData.GrnAvlQty) * Number(ItemData.ConversionFactor)
          );
          ItemData.StockInHand = String(
            Number(ItemData.StockInHand) * Number(ItemData.ConversionFactor)
          );
          ItemData.ItemChkQuantity = String(
            Number(ItemData.ItemChkQuantity) * Number(ItemData.ConversionFactor)
          );
          CurrentUOM = "SalesUnit";
        } else if (
          ItemData.PurchaseUnit == UOMId &&
          CurrentUOM == "SalesUnit"
        ) {
          ItemData.GRNRecQty =
            Number(ItemData.GRNRecQty) / Number(ItemData.ConversionFactor);

          ItemData.GrnAvlQty = String(
            Number(ItemData.GrnAvlQty) / Number(ItemData.ConversionFactor)
          );

          ItemData.StockInHand = String(
            Number(ItemData.StockInHand) / Number(ItemData.ConversionFactor)
          );
          ItemData.ItemChkQuantity = String(
            Number(ItemData.ItemChkQuantity) / Number(ItemData.ConversionFactor)
          );

          CurrentUOM = "PurchaseUnit";
        }
      } else {
        ItemData.UOMName = "";
      }
    };

    //Load Item Configuration
    const BrandDropdown: any = ref({
      ItemBrandoption: [],
      DuplitcateItemBrandoption: [],
    });

    const ModelNumberDropdown: any = ref({
      ItemModelNumberoption: [],
      DuplitcateItemModelNumberoption: [],
    });

    const SizeDropdown: any = ref({
      ItemSizeoption: [],
      DuplitcateItemSizeoption: [],
    });

    async function LoadItemConfigurations() {
      debugger;
      try {
        const response = await ItemConfigurationService.List();

        BrandDropdown.value.ItemBrandoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == usersData.OrganizationId &&
              f.ICTypeId == 1
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        BrandDropdown.value.DuplitcateItemBrandoption = JSON.parse(
          JSON.stringify(BrandDropdown.value.ItemBrandoption)
        );
        ModelNumberDropdown.value.ItemModelNumberoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == usersData.OrganizationId &&
              f.ICTypeId == 2
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        ModelNumberDropdown.value.DuplitcateItemModelNumberoption = JSON.parse(
          JSON.stringify(ModelNumberDropdown.value.ItemModelNumberoption)
        );

        SizeDropdown.value.ItemSizeoption = response["result"]
          .filter(
            (f) =>
              f.IsActive == true &&
              f.HospitalId == usersData.OrganizationId &&
              f.ICTypeId == 3
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        SizeDropdown.value.DuplitcateItemSizeoption = JSON.parse(
          JSON.stringify(SizeDropdown.value.ItemSizeoption)
        );
      } catch (error) {
        alert(error);
      }
    }

    let StockInHandObj = ref({
      BrandId: 0,
      ModelNumberId: 0,
      SizeId: 0,
    });

    const BrandOnChange = (BrandId) => {
      debugger;
      if (BrandId) {
        let options: any = BrandDropdown.value.ItemBrandoption.find(
          (item) => item["value"] == BrandId
        );
        ItemData.BrandName = options["Name"];
        ItemData.Brand = BrandId;

        StockInHandObj.value.BrandId = BrandId;
      }
      else {
        StockInHandObj.value.BrandId = 0;
        ItemData.BrandName = "";
      }

      getValues(
        ItemData.ItemId,
        ItemData.BarCodeNo || 0,
        StockInHandObj.value.BrandId || 0,
        StockInHandObj.value.ModelNumberId || 0,
        StockInHandObj.value.SizeId || 0,
        2, //Restrict Brand, Model and size Onchanges calling function for loop
        ItemData.IssueId || 0
      );
    };


    function BrandFilter(IdValue) {
      debugger;
      ItemData.Brand = ref();

      BrandDropdown.value.ItemBrandoption =
        BrandDropdown.value.DuplitcateItemBrandoption.filter((x) =>
          IdValue.split(",").includes(String(x.value))
        );
    }

    const ModelNumberOnChange = (ModelNumberId) => {
      debugger;
      if (ModelNumberId) {
        let options: any = ModelNumberDropdown.value.ItemModelNumberoption.find(
          (item) => item["value"] == ModelNumberId
        );
        ItemData.ModelNumberName = options["Name"];
        ItemData.ModelNumber = ModelNumberId;

        StockInHandObj.value.ModelNumberId = ModelNumberId;


      } else {
        StockInHandObj.value.ModelNumberId = 0;
        ItemData.ModelNumberName = "";
      }

      getValues(
        ItemData.ItemId,
        ItemData.BarCodeNo || 0,
        StockInHandObj.value.BrandId || 0,
        StockInHandObj.value.ModelNumberId || 0,
        StockInHandObj.value.SizeId || 0,
        2,
        ItemData.IssueId || 0 //Restrict Brand, Model and size Onchanges calling function for loop
      );
    };

    function ModelNumberFilter(IdValue) {
      debugger;
      ItemData.ModelNumber = ref();

      ModelNumberDropdown.value.ItemModelNumberoption =
        ModelNumberDropdown.value.DuplitcateItemModelNumberoption.filter((x) =>
          IdValue.split(",").includes(String(x.value))
        );
    }

    const SizeOnChange = (SizeId) => {
      debugger;
      if (SizeId) {
        let options: any = SizeDropdown.value.ItemSizeoption.find(
          (item) => item["value"] == SizeId
        );
        ItemData.SizeName = options["Name"];
        ItemData.Size = SizeId;

        StockInHandObj.value.SizeId = SizeId;
      } else {
        StockInHandObj.value.SizeId = 0;
        ItemData.SizeName = "";
      }

      getValues(
        ItemData.ItemId,
        ItemData.BarCodeNo || 0,
        StockInHandObj.value.BrandId || 0,
        StockInHandObj.value.ModelNumberId || 0,
        StockInHandObj.value.SizeId || 0,
        2,
        ItemData.IssueId || 0 //Restrict Brand, Model and size Onchanges calling function for loop
      );
    };

    function SizeFilter(IdValue) {
      debugger;
      ItemData.Size = ref();

      SizeDropdown.value.ItemSizeoption =
        SizeDropdown.value.DuplitcateItemSizeoption.filter((x) =>
          IdValue.split(",").includes(String(x.value))
        );
    }

    let ItemOnChangeValues;
    // Item onChange
    const ItemOnChange = async (ItemId) => {
      debugger;
      itemConfigDisabled.value = false;
      ItemOnChangeValues = ItemId;
      ItemData.ItemId = ItemId.value.Id;
      ItemData.BarCodeNo = ItemId.value?.BarCodeNo;
      ItemData.BarCode = ItemId.value?.BarCode;
      ItemData.Itemname1 = ItemId.value.Name;
      ItemData.ItemChkQuantity = ItemId.value.extraValue;

      itemConfigDisabled.value = ItemData.BarCodeNo ? true : false;

      ItemData.ReceivedQty =
        Number(ItemData.ItemChkQuantity) || ItemData.ReceivedQty;
      if (ItemData.ItemId) {
        itemDisabled.value = true;
        ItemInfoIcon.value = true;
        if (props.LasTTransactionDocType) {
          ItemLastTransicon.value = true;
        }
        ItemData.IsContractStatus = ItemId.value.IsContractStatus;
        if (props.commonItemProps?.IssueReturnFlag) {
          let FromStoreId = props.commonItemProps.storeId;
          let ToStoreId = props.commonItemProps?.tostoreId;
          const result = await StockInService.GetDocNoByBarCodeNo(
            FromStoreId,
            ToStoreId,
            props.commonItemProps.FromStoreBranchId == null || ""
              ? 0
              : props.commonItemProps.FromStoreBranchId,
            props.commonItemProps.ToStoreBranchId == null || ""
              ? 0
              : props.commonItemProps.ToStoreBranchId,
            usersData.OrganizationId,
            ItemData.BarCodeNo
          );

          LoadIssueNo.value.IssueNoOption = result["result"].map((item) => {
            item.name = item.DocNo;
            item.value = item.Id;
            return item;
          });
        } else {
          await getValues(
            ItemData.ItemId,
            ItemData.BarCodeNo || 0,
            StockInHandObj.value.BrandId || 0,
            StockInHandObj.value.ModelNumberId || 0,
            StockInHandObj.value.SizeId || 0,
            1,
            ItemData.IssueId || 0 //Restrict Brand, Model and size Onchanges calling function for loop
          );
        }
      }
      // loading1.value=false
    };

    //Show Item MRP
    async function getValues(
      ItemId,
      BarCodeNo,
      BrandId,
      ModelNumberId,
      SizeId,
      Flag,
      IssueId
    ) {
      debugger;

      EditId = ItemId;
      const StoreId = props.commonItemProps.storeId;
      try {
        const data_response = await Itemservice.GetItems(
          EditId,
          StoreId,
          BarCodeNo,
          BrandId,
          ModelNumberId,
          SizeId,
          usersData.OrganizationId,
          FromStoreBranchId,
          IssueId
        );
        data_response["result"].map((i1) => {
          i1.UnitRate =
            route.query.param == "GRNReturn" ? i1.UnitRate : i1.PurchasePrice;
          i1.GrnAvlQty1 = i1.GrnAvlQty;
          i1.ItemChkQuantity = i1.POQty;
          return i1;
        });

        if (Number(props.commonItemProps?.POFlag || 0) == 1) {
          let PODocType = "4,5";
          const response = await WithoutStockAffectService.GetUnitRateByPO(
            PODocType,
            StoreId,
            props.commonItemProps?.supplierId,
            data_response["result"][0].Id
          );
          debugger;
          if (response) {
            data_response["result"][0].UnitRate = response;
          }
        }

        let Id = 0,
          alreadyId = 0;
        let idChk = "",
          alreadyChk = "";

        if (
          props.commonItemProps.requestType == 1 &&
          props.commonItemProps.itemType == 1
        ) {
          Id = ItemData.ItemId;
          idChk = "ItemId";
          alreadyChk = "BarCodeNo";
          alreadyId = Number(ItemData.BarCodeNo);
        } else if (
          props.commonItemProps.itemType == 1 ||
          (props.commonItemProps.itemType == 3 &&
            ItemData.BarCodeNo &&
            ItemData.BarCodeNo != "0")
        ) {
          Id = Number(ItemData.BarCodeNo);
          idChk = "BarCodeNo";
          alreadyChk = "BarCodeNo";
          alreadyId = Number(ItemData.BarCodeNo);
        } else {
          Id = ItemData.ItemId;
          idChk = "ItemId";
          alreadyChk = "ItemId";
          alreadyId = Number(ItemData.ItemId);
        }
        let alreadyQty = AddData.value.filter((item) => {
          if (props.commonItemProps?.IsFilter == 3) {
            if (idChk == "ItemId") {
              return (
                item["" + alreadyChk + ""] == alreadyId &&
                item["BatchNo"] == (ItemData.BatchNo || "") &&
                item["ModelNumber"] == (ItemData.ModelNumber || 0) &&
                item["Size"] == (ItemData.Size || 0) &&
                item["Brand"] == (ItemData.Brand || 0) &&
                item["IsFreeItem"] == (ItemData.IsFreeItem || "0") &&
                item["IsFreeQtyItem"] == (ItemData.IsFreeQtyItem || "0")
                //  &&
                // item["SupplierBarCode"] == (ItemData.SupplierBarCode || "")
              );
            } else {
              return item["" + alreadyChk + ""] == alreadyId;
            }
          } else {
            if (idChk == "ItemId") {
              return (
                item["" + alreadyChk + ""] == alreadyId &&
                item["ModelNumber"] == (ItemData.ModelNumber || 0) &&
                item["Size"] == (ItemData.Size || 0) &&
                item["Brand"] == (ItemData.Brand || 0)
              );
            } else {
              return item["" + alreadyChk + ""] == alreadyId;
            }
          }
        });
        const filteredItem = props.isFilterData.filter(
          (item) => item["BarCodeNo"] == BarCodeNo
        )[0];
        let arr = props.isFilterData.filter((item) => {
          if (route.query.param == "GRNReturn" && route.query.refNo == "") {
            if (idChk == "ItemId") {
              return (
                item["" + idChk + ""] == Id &&
                item["BarCodeNo"] == BarCodeNo &&
                item["ModelNumber"] == (ItemData.ModelNumber || 0) &&
                item["Size"] == (ItemData.Size || 0) &&
                item["Brand"] == (ItemData.Brand || 0)
              );
            } else {
              return item["" + idChk + ""] == Id;
            }
          } else {
            if (props.commonItemProps?.IsFilter == 3) {
              if (idChk == "ItemId") {
                return (
                  item["" + idChk + ""] == Id &&
                  item["BatchNo"] == (ItemData.BatchNo || "") &&
                  item["ModelNumber"] == (ItemData.ModelNumber || 0) &&
                  item["Size"] == (ItemData.Size || 0) &&
                  item["Brand"] == (ItemData.Brand || 0) &&
                  item["IsFreeItem"] == (ItemData.IsFreeItem || "0") &&
                  item["IsFreeQtyItem"] == (ItemData.IsFreeQtyItem || "0")
                  // &&
                  // item["SupplierBarCode"] == (ItemData.SupplierBarCode || "")
                );
              } else {
                return item["" + idChk + ""] == Id;
              }
            } else {
              if (idChk == "ItemId") {
                return (
                  item["" + idChk + ""] == Id &&
                  item["ModelNumber"] == (ItemData.ModelNumber || 0) &&
                  item["Size"] == (ItemData.Size || 0) &&
                  item["Brand"] == (ItemData.Brand || 0)
                );
              } else {
                return item["" + idChk + ""] == Id;
              }
            }
          }
        });

        if (
          (alreadyQty.length > 0 &&
            alreadyQty[0]["StockDetailsId"] &&
            alreadyQty[0]?.["defaultQty"] != alreadyQty[0]["ItemQuantity"]) ||
          (alreadyQty.length > 0 && !alreadyQty[0]["StockDetailsId"]) ||
          (arr.length > 0 && alreadyQty.length > 0)
        ) {
          let chkQty = 0;
          if (alreadyQty[0]["StockDetailsId"]) {
            chkQty = Math.abs(
              Number(alreadyQty[0]["ItemQuantity"])
              // -
            );
          } else if (props.commonItemProps?.IssueReturnFlag) {
            chkQty = 0;
          } else {
            chkQty = alreadyQty[0]["ItemQuantity"];
          }
          ItemData.ItemQuantityInHand = String(
            data_response["result"][0]["StockInHand"] - Number(chkQty ?? 0)
          );
          ItemData.GRNRecQty = Number(data_response["result"][0]["GRNRecQty"]);
          let q1 =
            data_response["result"][0]["StockInHand"] - Number(chkQty ?? 0);
          ItemData.StockInHand = String(q1 > 0 ? q1 : 0);
          ItemData.IssuedQty = String(
            arr["0"]?.["IssuedQty"] - Number(chkQty ?? 0)
          );
          ItemData.RequestedQty = arr["0"]?.["RequestedQty"] ?? 0;

          ItemData.GRNId = arr["0"]?.["Id"] ?? "";

          ItemData.DocNo = arr["0"]?.["DocNo"] ?? "";
        } else {
          ItemData.IssuedQty = String(
            Number(arr["0"]?.["IssuedQty"] ?? 0) -
            Number(arr["0"]?.["ReturnsQty"] ?? 0)
          );
          ItemData.OrgItemsQty =
            Number(arr["0"]?.["OrgItemsQty"] ?? 0) -
            Number(arr["0"]?.["ReturnsQty"] ?? 0);
          ItemData.RequestedQty = arr["0"]?.["RequestedQty"] ?? 0;
          ItemData.ItemQuantityInHand =
            data_response["result"][0]["StockInHand"];
          ItemData.StockInHand = String(
            Number(data_response["result"][0]["StockInHand"])
          );
          if (Number(ItemData.StockInHand) > 0) {
            if (ItemData.PurchaseUnit == ItemData.UOM) {
              ItemData.StockInHand = String(
                Number(ItemData.StockInHand) / Number(ItemData.ConversionFactor)
              );
            }
          } else {
            ItemData.StockInHand = "0";
          }

          ItemData.GRNId = arr["0"]?.["Id"] ?? "";

          ItemData.DocNo = arr["0"]?.["DocNo"] ?? "";
        }
        if (Flag == 1) {
          ItemData.ColdChain = data_response["result"][0]["ColdChain"];
          ItemData.RoomId = data_response["result"][0]["RoomId"];
          ItemData.RackId = data_response["result"][0]["RackId"];
          ItemData.RowId = data_response["result"][0]["RowId"];
          ItemData.BoxId = data_response["result"][0]["BoxId"];
          ItemData.RoomName = data_response["result"][0]["RoomName"];
          ItemData.RackName = data_response["result"][0]["RackName"];
          ItemData.RowName = data_response["result"][0]["RowName"];
          ItemData.BoxName = data_response["result"][0]["BoxName"];
          ItemData.BatchNo = data_response["result"][0]["Batchno"] || "";
          ItemData.IsFreeItem = data_response["result"][0]["IsFreeItem"];
          ItemData.HSNManulCode = data_response["result"][0]["HSNManulCode"];
          ItemData.IsFreeQtyItem = data_response["result"][0]["IsFreeQtyItem"];
          ItemData.SupplierBarCode =
            data_response["result"][0]["SupplierBarCode"] || "";

          if (props.commonItemProps.itemType == 3) {
            FieldDisabled.value.Batch = true;
            FieldDisabled.value.ExpiryDate = true;
          } else {
            (FieldDisabled.value.Batch = false),
              (FieldDisabled.value.ExpiryDate = false);
          }

          ItemData.ItemChkQuantity =
            Number(ItemData.RequestedQty) != 0 && ItemData.RequestedQty
              ? ItemData.RequestedQty
              : ItemData.ItemChkQuantity;
          ItemFields.value.BatchRequired = data_response["result"][0][
            "BatchRequired"
          ]
            ? true
            : false;
          ItemFields.value.ExpiryDtRequired = data_response["result"][0][
            "ExpiryDtRequired"
          ]
            ? true
            : false;

          ItemFields.value.NoMrp = data_response["result"][0]["NoMrp"]
            ? false
            : true;

          // ItemFields.value.ManufactureDate = data_response["result"][0][
          //   "ManufactureDate"
          // ]
          //   ? true
          //   : false;

          ItemFields.value.ManufactureDtRequired = data_response["result"][0][
            "ManufactureDate"
          ]
            ? true
            : false;

          Object.keys(ItemData).forEach((key) => {
            if (
              data_response["result"][0][key] != undefined &&
              key != "StockInHand" &&
              key != "BarCodeNo"
            )
              ItemData[key] = data_response["result"][0][key];
          });

          //if (data_response["result"][0]["ExpiryDate"] != null) {
          //   ItemData.ExpiryDate =
          //     (await data_response["result"][0]["ExpiryDate"]) == "01-01-0001" || data_response["result"][0]["ExpiryDate"] == "01-01-1900"
          //       ? ""
          //       : data_response["result"][0]["ExpiryDate"];
          // }

          if (props.commonItemProps?.GRNFlag) {
            if (data_response["result"][0]["ExpiryDate"] !== null) {
              const expiryDate = data_response["result"][0]["ExpiryDate"];
              ItemData.ExpiryDate =
                expiryDate === "01-01-0001" || expiryDate === "01-01-1900"
                  ? ""
                  : expiryDate;
            }
          } else {
            if (data_response["result"][0]["ExpiryDate"] != null) {
              ItemData.ExpiryDate =
                (await data_response["result"][0]["ExpiryDate"]) ==
                  "01-01-0001" ||
                  data_response["result"][0]["ExpiryDate"] == "01-01-1900"
                  ? ""
                  : data_response["result"][0]["ExpiryDate"];
            }
          }

          if (data_response["result"][0]["ManufactureDT"] != null) {
            ItemData.ManufactureDate =
              (await data_response["result"][0]["ManufactureDT"]) ==
                "01-01-0001"
                ? null
                : data_response["result"][0]["ManufactureDT"];
          }

          // ItemData.ManufactureDt = await data_response["result"][0]["ManufactureDate"];

          ItemData.POSupplierId = data_response["result"][0]["POSupplierId"];
          ItemData.ItemProductId = data_response["result"][0]["ItemProductId"];

          ItemData.POSupplierName =
            data_response["result"][0]["POSupplierName"];
          ItemData.Asset = data_response["result"][0]["Asset"];
          ItemData.IsBrand = data_response["result"][0]["IsBrand"];
          ItemData.IsModel = data_response["result"][0]["IsModel"];
          ItemData.IsSize = data_response["result"][0]["IsSize"];
          // ItemData.IsContractStatus = ItemListData.IsContractStatus;
          // LoadRoom();
          // LoadRack();
          // LoadRow();
          // LoadBox();
          // PackageSizeOnChange(data_response["result"][0]["PackSizeId"]);
          if (
            data_response["result"][0]["Brand"]
              .split(",")
              .map((item) => Number(item)).length == 1
          ) {
            BrandFilter(data_response["result"][0]["Brand"]);
            BrandOnChange(Number(data_response["result"][0]["Brand"]));
          } else {
            BrandFilter(data_response["result"][0]["Brand"]);
          }

          if (
            data_response["result"][0]["ModelNumber"]
              .split(",")
              .map((item) => Number(item)).length == 1
          ) {
            ModelNumberFilter(data_response["result"][0]["ModelNumber"]);
            ModelNumberOnChange(
              Number(data_response["result"][0]["ModelNumber"])
            );
          } else {
            ModelNumberFilter(data_response["result"][0]["ModelNumber"]);
          }

          if (
            data_response["result"][0]["Size"]
              .split(",")
              .map((item) => Number(item)).length == 1
          ) {
            SizeFilter(data_response["result"][0]["Size"]);
            SizeOnChange(Number(data_response["result"][0]["Size"]));
          } else {
            SizeFilter(data_response["result"][0]["Size"]);
          }
          debugger;
          if (props.commonItemProps?.UOMFlag) {
            LoadUOM.value.UOMoption = LoadUOM.value.DuplicateUOMoption.filter(
              (items: any) =>
                items.Id == data_response["result"][0]["PurchaseUnit"] ||
                items.Id == data_response["result"][0]["SalesUnit"]
            );
          } else {
            LoadUOM.value.UOMoption = LoadUOM.value.DuplicateUOMoption.filter(
              (items: any) =>
                items.Id == data_response["result"][0]["PurchaseUnit"]
            );
          }

          if (props.commonItemProps?.ConsumptionFlag) {
            UOMOnChange(data_response["result"][0]["SalesUnit"]);
          } else if (
            props.commonItemProps?.GRNReturnFlag ||
            props.commonItemProps?.IssueReturnFlag
          ) {
            if (
              Number(data_response["result"][0]["UOM"]) ==
              Number(data_response["result"][0]["SalesUnit"])
            ) {
              CurrentUOM = "SalesUnit";
            } else if (
              Number(data_response["result"][0]["UOM"]) ==
              Number(data_response["result"][0]["PurchaseUnit"])
            ) {
              CurrentUOM = "PurchaseUnit";
            }
            UOMOnChange(Number(data_response["result"][0]["UOM"]));
          } else {
            UOMOnChange(data_response["result"][0]["PurchaseUnit"]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function IsAdd() {
      debugger;
      // props.commonItemProps.type==1 means from issue form
      if (props.commonItemProps.type == 1) {
        if (
          Number(ItemData.StockInHand) < Number(ItemData.ItemQuantity) &&
          props.commonItemProps.fieldType != 1
        ) {
          warningmsgcontent.value.warningcontent =
            "You Don't Have Qty In Your Store";
          wariningPopup.value = true;
        } else if (
          Number(ItemData.GrnAvlQty) < Number(ItemData.ItemQuantity) &&
          props.commonItemProps.fieldType == 1 &&
          props.showFields.GrnAvlQty?.show
        ) {
          warningmsgcontent.value.warningcontent =
            "You Don't Have Qty In Your Store";
          wariningPopup.value = true;
        } else if (
          Number(ItemData.IssuedQty) < Number(ItemData.ItemQuantity) &&
          props.commonItemProps.fieldType == 1 &&
          props.showFields.GrnAvlQty?.show == false
        ) {
          warningmsgcontent.value.warningcontent =
            "You Don't Have Qty In Your Store";
          wariningPopup.value = true;
        } else {
          let alreadyQty;
          if (props.commonItemProps?.IssueReturnFlag) {
            alreadyQty = AddData.value.find(
              (item) =>
                item.ItemId == ItemData.ItemId &&
                item.IssueId == ItemData.IssueId
            );
          } else {
            alreadyQty = AddData.value.find(
              (item) =>
                item.Id == ItemData.ItemId || item.ItemId == ItemData.ItemId
            );
          }

          if (
            Number(ItemData.ItemQuantity) +
            Number(alreadyQty?.ItemQuantity ?? 0) >
            Number(ItemData.ItemChkQuantity) &&
            ItemData.ItemChkQuantity != undefined &&
            ItemData.ItemChkQuantity != ""
          ) {
            EditmodelQty.value = true;
          } else {
            await AddItemsQty();
          }
        }
      } else {
        await AddItemsQty();
      }
    }

    async function AddItemsQty() {
      debugger;
      let itemCount: number = 0;
      if (
        props.commonItemProps.itemType == 1 ||
        (props.commonItemProps.itemType == 3 &&
          ItemData.BarCodeNo &&
          ItemData.BarCodeNo != "0")
      ) {
        itemCount = AddData.value.filter(
          (item) => item.BarCodeNo == ItemData.BarCodeNo
        ).length;
      } else {
        if (props.commonItemProps?.IsFilter == 3) {
          debugger;
          if (props.showFields.Batch?.show && ItemFields.value.BatchRequired) {
            let BatchNoExist = AddData.value.find(
              (item) => item.BatchNo == ItemData.BatchNo
            );
            if (BatchNoExist) {
              toast.add({
                severity: "warn",
                summary: "Duplicate Batch",
                detail: `This batch (${ItemData.BatchNo}) is already added against the item: ${BatchNoExist.Itemname1}.`,
                life: 3000,
              });
              ItemData.BatchNo = "";
              resetField("BatchNo");

              return;
            }
          }

          itemCount = AddData.value.filter(
            (item) =>
              item.ItemId == ItemData.ItemId &&
              item.BatchNo == (ItemData.BatchNo || "") &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0) &&
              item.IsFreeItem == (ItemData.IsFreeItem || "0") &&
              item.IsFreeQtyItem == (ItemData.IsFreeQtyItem || "0")
            //  &&
            // item.SupplierBarCode == (ItemData.SupplierBarCode || "")
          ).length;
        } else if (props.commonItemProps?.IssueReturnFlag) {
          itemCount = AddData.value.filter(
            (item) =>
              item.ItemId == ItemData.ItemId &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0) &&
              item.IssueId == (ItemData.IssueId || 0)
          ).length;
        } else {
          itemCount = AddData.value.filter(
            (item) =>
              item.ItemId == ItemData.ItemId &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0)
          ).length;
        }
      }
      if (itemCount > 0) {
        if (props.commonItemProps?.DirectIssueFlag) {
          toast.add({
            severity: "warn",
            summary: "Duplicate Entry",
            detail: "This item has already been added.",
            life: 3000,
          });
        } else {
          Editmodel.value = true;
        }
      } else {
        await AmountCalculation();
      }
    }

    function QuantityDataChange() {
      debugger;
      let Id = 0;
      let idChk = "";
      if (
        props.commonItemProps.itemType == 1 ||
        (props.commonItemProps.itemType == 3 &&
          ItemData.BarCodeNo &&
          ItemData.BarCodeNo != "0")
      ) {
        Id = Number(ItemData.BarCodeNo);
        idChk = "BarCodeNo";
      } else if (props.commonItemProps?.IssueReturnFlag) {
        Id = ItemData.IssueId;
        idChk = "IssueId";
      } else {
        Id = ItemData.ItemId;
        idChk = "ItemId";
      }

      Object.values(AddData.value).forEach((item: any) => {
        if (props.commonItemProps?.IsFilter == 3) {
          if (
            (idChk == "BarCodeNo" &&
              item["" + idChk + ""] == Id &&
              item.BatchNo == (ItemData.BatchNo || "") &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0) &&
              item.IsFreeItem == (ItemData.IsFreeItem || "0") &&
              item.IsFreeQtyItem == (ItemData.IsFreeQtyItem || "0")) ||
            //  &&
            // item.SupplierBarCode == (ItemData.SupplierBarCode || "")
            (idChk == "ItemId" &&
              item["" + idChk + ""] == Id &&
              item.BatchNo == (ItemData.BatchNo || "") &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0) &&
              item.IsFreeItem == (ItemData.IsFreeItem || "0") &&
              item.IsFreeQtyItem == (ItemData.IsFreeQtyItem || "0"))
            // &&
            // item.SupplierBarCode == (ItemData.SupplierBarCode || "")
          ) {
            ItemDataTotalValue.totalothercharges = Math.max(
              ItemDataTotalValue.totalothercharges -
              Number(item.othercharges ?? 0),
              0
            );
            ItemDataTotalValue.totalservicecharges = Math.max(
              ItemDataTotalValue.totalservicecharges -
              Number(item.servicecharges ?? 0),
              0
            );
            ItemDataTotalValue.totaltransportcharges = Math.max(
              ItemDataTotalValue.totaltransportcharges -
              Number(item.transportcharges ?? 0),
              0
            );
            ItemDataTotalValue.grossamount = Math.max(
              ItemDataTotalValue.grossamount - item.Rate,
              0
            );
            ItemDataTotalValue.totaltaxamount = Math.max(
              ItemDataTotalValue.totaltaxamount -
              Number(item.Purchasetaxamount ?? 0),
              0
            );
            ItemDataTotalValue.totaldiscountamount = Math.max(
              ItemDataTotalValue.totaldiscountamount -
              Number(item.DiscountAmount ?? 0),
              0
            );
            let qty1: any =
              Number(item.ItemQuantity) + Number(ItemData.ItemQuantity);
            ItemData.ItemQuantity = qty1;
          }
        } else {
          if (
            (idChk == "BarCodeNo" &&
              item["" + idChk + ""] == Id &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0)) ||
            (idChk == "ItemId" &&
              item["" + idChk + ""] == Id &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0)) ||
            (idChk == "IssueId" &&
              item["" + idChk + ""] == Id &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0))
          ) {
            ItemDataTotalValue.totalothercharges = Math.max(
              ItemDataTotalValue.totalothercharges -
              Number(item.othercharges ?? 0),
              0
            );
            ItemDataTotalValue.totalservicecharges = Math.max(
              ItemDataTotalValue.totalservicecharges -
              Number(item.servicecharges ?? 0),
              0
            );
            ItemDataTotalValue.totaltransportcharges = Math.max(
              ItemDataTotalValue.totaltransportcharges -
              Number(item.transportcharges ?? 0),
              0
            );
            ItemDataTotalValue.grossamount = Math.max(
              ItemDataTotalValue.grossamount - item.Rate,
              0
            );
            ItemDataTotalValue.totaltaxamount = Math.max(
              ItemDataTotalValue.totaltaxamount -
              Number(item.Purchasetaxamount ?? 0),
              0
            );
            ItemDataTotalValue.totaldiscountamount = Math.max(
              ItemDataTotalValue.totaldiscountamount -
              Number(item.DiscountAmount ?? 0),
              0
            );
            let qty1: any =
              Number(item.ItemQuantity) + Number(ItemData.ItemQuantity);
            if (props.commonItemProps.type == 1) {
              if (qty1 > item.StockInHand) {
                warningmsgcontent.value.warningcontent =
                  "You Don't Have Qty In Your Store";
                wariningPopup.value = true;
                return;
              }
            }

            ItemData.ItemQuantity = qty1;
          }
        }
      });
      AmountCalculation();
    }

    async function addQuantity() {
      debugger;
      if (
        props.commonItemProps.itemType == 1 ||
        (props.commonItemProps.itemType == 3 &&
          ItemData.BarCodeNo &&
          ItemData.BarCodeNo != "0")
      ) {
        Object.values(AddData.value).forEach((item: any) => {
          if (item.BarCodeNo == ItemData.BarCodeNo) {
            Object.keys(item).forEach((key) => {
              if (ItemData[key] && key != "StockInHand") {
                if (
                  key == "FromDate" ||
                  key == "ToDate" ||
                  key == "ExpiryDate" ||
                  key == "ManufactureDate"
                ) {
                  const regex = /^\d{2}-\d{2}-\d{4}$/;
                  let Date = regex.test(ItemData[key])
                    ? ItemData[key]
                    : moment(ItemData[key]).format("DD-MM-YYYY");
                  item[key] = Date;
                } else {
                  item[key] = ItemData[key];
                }
              }
            });
          }
        });
      } else {
        Object.values(AddData.value).forEach((item: any) => {
          if (props.commonItemProps?.IsFilter == 3) {
            if (
              item.ItemId == ItemData.ItemId &&
              item.BatchNo == (ItemData.BatchNo || 0) &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0) &&
              item.IsFreeItem == (ItemData.IsFreeItem || "0") &&
              item.IsFreeQtyItem == (ItemData.IsFreeQtyItem || "0")
              // &&
              // item.SupplierBarCode == (ItemData.SupplierBarCode || "")
            ) {
              Object.keys(item).forEach((key) => {
                if (ItemData[key] && key != "StockInHand") {
                  if (
                    key == "FromDate" ||
                    key == "ToDate" ||
                    key == "ExpiryDate" ||
                    key == "ManufactureDate"
                  ) {
                    const regex = /^\d{2}-\d{2}-\d{4}$/;
                    let Date = regex.test(ItemData[key])
                      ? ItemData[key]
                      : moment(ItemData[key]).format("DD-MM-YYYY");
                    item[key] = Date;
                  } else {
                    item[key] = ItemData[key];
                  }
                }
              });
            }
          } else if (props.commonItemProps?.IssueReturnFlag) {
            if (
              item.ItemId == ItemData.ItemId &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0) &&
              item.IssueId == (ItemData.IssueId || 0)
            ) {
              Object.keys(item).forEach((key) => {
                if (ItemData[key] && key != "StockInHand") {
                  if (
                    key == "FromDate" ||
                    key == "ToDate" ||
                    key == "ExpiryDate" ||
                    key == "ManufactureDate"
                  ) {
                    const regex = /^\d{2}-\d{2}-\d{4}$/;
                    let Date = regex.test(ItemData[key])
                      ? ItemData[key]
                      : moment(ItemData[key]).format("DD-MM-YYYY");
                    item[key] = Date;
                  } else {
                    item[key] = ItemData[key];
                  }
                }
              });
            }
          } else {
            if (
              item.ItemId == ItemData.ItemId &&
              item.ModelNumber == (ItemData.ModelNumber || 0) &&
              item.Size == (ItemData.Size || 0) &&
              item.Brand == (ItemData.Brand || 0)
            ) {
              Object.keys(item).forEach((key) => {
                if (ItemData[key] && key != "StockInHand") {
                  if (
                    key == "FromDate" ||
                    key == "ToDate" ||
                    key == "ExpiryDate" ||
                    key == "ManufactureDate"
                  ) {
                    const regex = /^\d{2}-\d{2}-\d{4}$/;
                    let Date = regex.test(ItemData[key])
                      ? ItemData[key]
                      : moment(ItemData[key]).format("DD-MM-YYYY");
                    item[key] = Date;
                  } else {
                    item[key] = ItemData[key];
                  }
                }
              });
            }
          }
        });
      }
      Editmodel.value = false;
      EditmodelQty.value = false;
      await emit("taxcalculation", AddData.value);
      await IsClear();
      toast.add({
        severity: "success",
        summary: "Quantity Added Successfully",
        detail: "The quantity has been successfully added.",
        life: 3000,
      });
    }

    async function AddItems() {
      debugger;
      const regex = /^\d{2}-\d{2}-\d{4}$/;
      let FromDate = regex.test(ItemData.FromDate)
        ? ItemData.FromDate
        : moment(ItemData.FromDate).format("DD-MM-YYYY");
      let ToDate = regex.test(ItemData.ToDate)
        ? ItemData.ToDate
        : moment(ItemData.ToDate).format("DD-MM-YYYY");

      ItemData.ExpiryDate = ItemData.ExpiryDate
        ? regex.test(ItemData.ExpiryDate)
          ? ItemData.ExpiryDate
          : moment(ItemData.ExpiryDate).format("DD-MM-YYYY")
        : "";
      let ManufactureDate = ItemData.ManufactureDate
        ? regex.test(ItemData.ManufactureDate)
          ? ItemData.ManufactureDate
          : moment(ItemData.ManufactureDate).format("DD-MM-YYYY")
        : "";

      let data1 = {};
      data1["ItemQuantity"] = ItemData.ItemQuantity;
      data1["PoQty"] = ItemData.ItemQuantity;

      data1["CategoryId"] = ItemData.CategoryId;
      data1["ItemCategory1"] = ItemData.CategoryLableName;
      data1["ItemId"] = ItemData.ItemId;
      data1["Itemname1"] = ItemData.Itemname1;
      data1["FromDate"] = FromDate;
      data1["ToDate"] = ToDate;
      data1["PackSizeId"] = ItemData.PackSizeId || 0;
      data1["PackSizename1"] = ItemData.PackSizename1 || "";
      data1["UOM"] = ItemData.UOM;

      data1["UOMName"] = ItemData.UOMName;
      data1["PackSizeQty"] = ItemData.PackSizeQty;
      data1["BatchNo"] = ItemData.BatchNo;
      data1["UnitRate"] = ItemData.UnitRate || 0;
      data1["ItemCode"] = ItemData.ItemCode;
      data1["HSNCode"] = ItemData.HSNCode;
      data1["HSNId"] = ItemData.HSNId;
      data1["MRP"] = ItemData.MRP;
      data1["ReOrderLevel"] = ItemData.ReOrderLevel;
      data1["StockDetailsId"] = 0;
      data1["SalesUnit"] = ItemData.SalesUnit;
      data1["PurchaseUnit"] = ItemData.PurchaseUnit;
      data1["SalesUnitName"] = ItemData.SalesUnitName;
      data1["SalesPrice"] = ItemData.SalesPrice;
      data1["PurchasePrice"] = ItemData.PurchasePrice;

      data1["SalesPercentage"] = ItemData.SalesPercentage;
      data1["Salestaxamount"] = ItemData.Salestaxamount;

      data1["PurchasePercentage"] = ItemData.PurchasePercentage;
      data1["Purchasetaxamount"] = ItemData.Purchasetaxamount;

      data1["SGSTTax"] = ItemData.SGSTTax;
      data1["SGSTTaxAmount"] = ItemData.SGSTTaxAmount;
      data1["CGSTTax"] = ItemData.CGSTTax;
      data1["CGSTTaxAmount"] = ItemData.CGSTTaxAmount;
      data1["IGSTTax"] = ItemData.IGSTTax;
      data1["IGSTTaxAmount"] = ItemData.IGSTTaxAmount;
      data1["Amount"] = ItemData.Amount;

      data1["Totalvalue"] = ItemData.Totalvalue;
      data1["Discount"] = ItemData.Discount;
      data1["DiscountAmount"] = ItemData.DiscountAmount;
      data1["Discountamount"] = ItemData.DiscountAmount;
      data1["Description"] = ItemData.Description;
      data1["Rate"] = ItemData.Rate;
      data1["transportcharges"] = ItemData.transportcharges;
      data1["Transportcharges"] = ItemData.transportcharges;
      data1["servicecharges"] = ItemData.servicecharges;
      data1["Servicecharges"] = ItemData.servicecharges;
      data1["othercharges"] = ItemData.othercharges;
      // data1["Othercharges"] = ItemData.othercharges;
      data1["taxamount"] = ItemData.taxamount;
      data1["StockInHand"] = ItemData.StockInHand;
      data1["IssuedQty"] = ItemData.IssuedQty;
      data1["RequestedQty"] = ItemData.RequestedQty;
      data1["BarCode"] = ItemData.BarCode;
      data1["BarCodeNo"] = ItemData.BarCodeNo;
      data1["RateContractCount"] = ItemData.RateContractCount;
      data1["ExpiryDate"] = ItemData.ExpiryDate;
      data1["BatchRequired"] = ItemFields.value.BatchRequired;
      data1["ExpiryDtRequired"] = ItemFields.value.ExpiryDtRequired;

      data1["NoMrp"] = ItemFields.value.NoMrp;
      data1["RequiredQuantity"] = Math.max(
        0,
        ItemData.ReOrderLevel - Number(ItemData.StockInHand)
      );

      data1["PurchaseUnitName"] = ItemData.PurchaseUnitName;
      data1["PurchaseType"] = ItemData.PurchaseType;
      data1["SalesType"] = ItemData.SalesType;

      data1["POSupplierId"] = ItemData.POSupplierId;
      data1["POSupplierName"] = ItemData.POSupplierName;

      data1["ItemProductId"] = ItemData.ItemProductId;

      data1["BrandName"] = ItemData.BrandName;
      data1["Brand"] = ItemData.Brand || 0;

      data1["ModelNumberName"] = ItemData.ModelNumberName;
      data1["ModelNumber"] = ItemData.ModelNumber || 0;

      data1["SizeName"] = ItemData.SizeName;
      data1["Size"] = ItemData.Size || 0;
      data1["StockInId"] = ItemData.StockInId || 0;
      data1["StockInDetailId"] = ItemData.StockInDetailId || 0;

      data1["IsConsigneeItem"] = ItemData.IsConsigneeItem || 0;
      data1["SupplierId"] = ItemData.SupplierId || 0;
      data1["ColdChain"] = ItemData.ColdChain;

      data1["GRNId"] = ItemData.GRNId;
      data1["DocNo"] = ItemData.DocNo;
      data1["ReasonId"] = ItemData.ReasonId;
      data1["ReasonName"] = ItemData.ReasonName;

      data1["DocNo"] = ItemData.DocNo;
      data1["RoomId"] = ItemData.RoomId;
      data1["RackId"] = ItemData.RackId;
      data1["RowId"] = ItemData.RowId;
      data1["BoxId"] = ItemData.BoxId;
      data1["RoomName"] = ItemData.RoomName;
      data1["RackName"] = ItemData.RackName;
      data1["RowName"] = ItemData.RowName;
      data1["BoxName"] = ItemData.BoxName;
      data1["ManufactureDate"] = ManufactureDate;
      // data1["ManufactureDate"] = ItemData.ManufactureDate;
      data1["ManufactureDtRequired"] = ItemFields.value.ManufactureDtRequired;
      data1["IsFreeItem"] = ItemData.IsFreeItem;
      data1["HSNManulCode"] = ItemData.HSNManulCode;
      data1["GrnAvlQty"] = ItemData.GrnAvlQty;
      data1["DispensingName"] = ItemData.SalesUnitName;
      data1["OrderingName"] = ItemData.PurchaseUnitName;
      data1["PickedQty"] = ItemData.PickedQty;
      data1["InTransist"] = ItemData.InTransist;
      data1["ConversionFactor"] = ItemData.ConversionFactor;
      data1["Asset"] = ItemData.Asset;
      data1["defaultStockIn"] = ItemData.ReceivedQty;
      data1["ReceivedQty"] = ItemData.ReceivedQty;
      data1["ItemChkQuantity"] = ItemData.ReceivedQty;
      data1["GRNRecQty"] = ItemData.GRNRecQty;
      data1["IsFreeQtyItem"] = ItemData.IsFreeQtyItem;
      data1["ToStoreCategoryItem"] = 1;
      data1["IssueNo"] = ItemData.IssueNo;
      data1["IssueDate"] = ItemData.IssueDate;
      data1["IssueId"] = ItemData.IssueId;
      data1["ReturnedQty"] = ItemData.ReturnedQty;

      data1["SupplierBarCode"] = ItemData.SupplierBarCode;
      data1["ToStoreCategoryItem"] = 1;
      // data1["BatchChecked"] = ItemData.BatchChecked;
      // data1["SupplierChecked"] = ItemData.SupplierChecked;

      AddData.value.push(data1);
      console.log(AddData.value);
      emit("additemclick", AddData.value);
      emit("taxcalculation", AddData.value);
      EditmodelQty.value = false;
      console.log(AddData.value);

      if (
        props.commonItemProps?.IsFilter == 3 &&
        ItemFields.value.BatchRequired
      ) {
        // resetField('Quantity');
        resetField("BatchNo");
        resetField("SupplierBarCode");
        // resetField('ExpiryDate');
        // Explicitly clear the ExpiryDate value to ensure validation is reset
        // ItemData.ExpiryDate = "";
      } else {
        await IsClear();
        itemDisabled.value = false;
        itemConfigDisabled.value = false;
        wariningPopup.value = false;
        await LoadItemConfigurations();
      }

      // resetForm()
      toast.add({
        severity: "success",
        summary: "Successful",
        detail: "The item has been added successfully.",
        life: 3000,
      });
    }

    //Calculation Part
    async function AmountCalculation() {
      debugger;
      // Check if Brand is required but not selected
      if (
        (Boolean(ItemData.IsBrand) ||
          Boolean(props.showFields?.Brand?.require)) &&
        !ItemData.Brand
      ) {
        toast.add({
          severity: "warn",
          summary: "Required",
          detail: "Brand is required for this item",
          life: 3000,
        });
        return;
      }

      if (
        (Boolean(ItemData.IsModel) ||
          Boolean(props.showFields?.ModelNumber?.require)) &&
        !ItemData.ModelNumber
      ) {
        toast.add({
          severity: "warn",
          summary: "Required",
          detail: "Model is required for this item",
          life: 3000,
        });
        return;
      }

      if (
        (Boolean(ItemData.IsSize) ||
          Boolean(props.showFields?.Size?.require)) &&
        !ItemData.Size
      ) {
        toast.add({
          severity: "warn",
          summary: "Required",
          detail: "Size is required for this item",
          life: 3000,
        });
        return;
      }

      let qtyitem = 0;
      if (props.commonItemProps?.IsFilter === 2) {
        //  const Qty = Number(ItemData.ItemQuantity) / Number(ItemData.PackSizeQty);
        let Qty = Number(ItemData.ItemQuantity);
        // if (ItemData.UOM == ItemData.PurchaseUnit) {
        //   Qty = Number(ItemData.ItemQuantity) * Number(ItemData.ConversionFactor)
        // }
        qtyitem = Number(Qty);
      } else {
        let Qty = Number(ItemData.ItemQuantity);
        // if (ItemData.UOM == ItemData.PurchaseUnit) {
        //   Qty = Number(ItemData.ItemQuantity) * Number(ItemData.ConversionFactor)
        // }
        qtyitem = Number(Qty);
      }
      let data = {
        qty: qtyitem,
        totalQty: ItemDataTotalValue.totalqty,
        unitrate: ItemData.UnitRate || 0,
        rate: 0,
        totalrate: ItemDataTotalValue.totalrate,
        taxPercentage: 0,
        taxamount: 1,
        totalvalue: 0,
        grossamount: ItemDataTotalValue.grossamount,
        toatltaxamount: ItemDataTotalValue.totaltaxamount,
        netvalue: 0,
        discountpercentage: ItemData.Discount || 0,
        discountamount: 0,
        totaldiscountamount: ItemDataTotalValue.totaldiscountamount,
        Salestaxpercentage: ItemData.SalesPercentage,
        Salesrate: ItemData.SalesPrice,
        Purchasetaxpercentage: ItemData.PurchasePercentage,
        Purchaserate: ItemData.PurchasePrice,
        Transportcharges: ItemData.transportcharges,
        Servicecharges: ItemData.servicecharges,
        Othercharges: ItemData.othercharges,
        Totalothercharges: ItemDataTotalValue.totalothercharges,
        Totalservicecharges: ItemDataTotalValue.totalservicecharges,
        Totaltransportcharges: ItemDataTotalValue.totaltransportcharges,
        PurchaseType: ItemData.PurchaseType,
        SalesType: ItemData.SalesType,
      };

      const dataResponse = await CommonService.TaxDiscalulation(data);
      debugger;
      console.log(dataResponse);
      ItemData.taxamount = dataResponse["result"].Toatltaxamount;
      ItemData.totaldiscountamount = dataResponse["result"].Totaldiscountamount;
      ItemData.Totalvalue =
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
          (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
          ? "0.00"
          : dataResponse["result"].Totalvalue;
      ItemData.DiscountAmount = dataResponse["result"].Discountamount;
      ItemData.grossamount = dataResponse["result"].grossamount;
      ItemData.netamount = dataResponse["result"].Netvalue;
      ItemData.totalqty = dataResponse["result"].TotalQty;
      ItemData.totalothercharges = dataResponse["result"].Totalothercharges;
      ItemData.totaltransportcharges =
        dataResponse["result"].Totaltransportcharges;
      ItemData.totalservicecharges = dataResponse["result"].Totalservicecharges;

      ItemData.SalesPercentage =
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
          (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
          ? "0.00"
          : dataResponse["result"].Salestaxpercentage;

      ItemData.Salestaxamount =
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
          (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
          ? "0.00"
          : dataResponse["result"].Salestaxamount;

      ItemData.PurchasePercentage =
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
          (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
          ? "0.00"
          : dataResponse["result"].Purchasetaxpercentage;

      ItemData.Purchasetaxamount =
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
          (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
          ? "0.00"
          : Number(dataResponse["result"].Purchasetaxamount).toFixed(2);

      if (usersData.BranchStateId != props.commonItemProps?.SupllierStateId) {
        ItemData.SGSTTax = 0;
        ItemData.SGSTTaxAmount =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? "0.00"
            : Number(0.0).toFixed(2);

        ItemData.CGSTTax = 0;
        ItemData.CGSTTaxAmount =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? "0.00"
            : Number(0.0).toFixed(2);

        ItemData.IGSTTax =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? "0.00"
            : dataResponse["result"].Purchasetaxpercentage;

        ItemData.IGSTTaxAmount =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? "0.00"
            : Number(dataResponse["result"].Purchasetaxamount).toFixed(2);
      } else {
        ItemData.SGSTTax =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? 0.0
            : Number(dataResponse["result"].Purchasetaxpercentage) / 2;

        ItemData.SGSTTaxAmount =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? "0.00"
            : Number(
              Number(dataResponse["result"].Purchasetaxamount) / 2
            ).toFixed(2);

        ItemData.CGSTTax =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? 0.0
            : Number(dataResponse["result"].Purchasetaxpercentage) / 2;

        ItemData.CGSTTaxAmount =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? "0.00"
            : Number(
              Number(dataResponse["result"].Purchasetaxamount) / 2
            ).toFixed(2);

        ItemData.IGSTTax = 0;
        ItemData.IGSTTaxAmount =
          (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
            (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
            ? "0.00"
            : Number(0.0).toFixed(2);
      }
      ItemData.UnitRate =
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
          (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
          ? "0.00"
          : Number(ItemData.UnitRate).toFixed(2);
      if (
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
        (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
      ) {
        resetField("UnitRate");
      }

      ItemData.Rate =
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
          (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
          ? "0.00"
          : Number(dataResponse["result"].rate).toFixed(2);

      ItemData.Amount =
        (ItemData.IsFreeItem && ItemData.IsFreeItem == "1") ||
          (ItemData.IsFreeQtyItem && ItemData.IsFreeQtyItem == "1")
          ? "0.00"
          : Number(
            Number(ItemData.Rate) +
            Number(ItemData.SGSTTaxAmount) +
            Number(ItemData.CGSTTaxAmount) +
            Number(ItemData.IGSTTaxAmount)
          ).toFixed(2);

      // this for calulation purpose

      ItemDataTotalValue.totaltaxamount = dataResponse["result"].Toatltaxamount;
      ItemDataTotalValue.totaldiscountamount =
        dataResponse["result"].Totaldiscountamount;
      ItemDataTotalValue.grossamount = dataResponse["result"].grossamount;
      ItemDataTotalValue.netamount = dataResponse["result"].Netvalue;
      ItemDataTotalValue.totalqty = dataResponse["result"].TotalQty;
      ItemDataTotalValue.totalothercharges =
        dataResponse["result"].Totalothercharges;
      ItemDataTotalValue.totaltransportcharges =
        dataResponse["result"].Totaltransportcharges;
      ItemDataTotalValue.totalservicecharges =
        dataResponse["result"].Totalservicecharges;
      emit("calculation", ItemData);

      if (ItemData.IsEdit == 1) {
        await IsUpdate();
      } else if (Editmodel.value == true) {
        await addQuantity();
      } else {
        await AddItems();
      }

      if (
        props.commonItemProps?.IsFilter == 3 &&
        ItemFields.value.BatchRequired
      ) {
        // ItemData.ItemQuantity = "";
        ItemData.BatchNo = "";
        ItemData.SupplierBarCode = "";
        // ItemData.ExpiryDate = "";
        ItemData.IsFreeItem = "0";
        ItemData.IsFreeQtyItem = "0";
      } else {
        ItemFields.value.BatchRequired = false;
        ItemFields.value.ExpiryDtRequired = false;
        ItemFields.value.NoMrp = true;
        // ItemFields.value.ManufactureDate = false;
        ItemFields.value.ManufactureDtRequired = false;
      }
    }

    const copyinsert_data = JSON.parse(JSON.stringify(ItemData));
    const copyinsert_LoadCategoryName = JSON.parse(
      JSON.stringify(LoadCategoryName.value)
    );
    const copyinsert_LoadItemName = JSON.parse(
      JSON.stringify(LoadItemName.value)
    );

    // function IsClear() {
    //   debugger;
    //   ItemData.ItemQuantity = "";
    //   ItemData.PackSizeId = ref();
    //   ItemData.UOM = ref();
    //   ItemData.Brand = ref();
    //   ItemData.ModelNumber = ref();
    //   ItemData.Size = ref();
    //   resetForm();

    //   Object.assign(ItemData, copyinsert_data);
    //   StockInHandObj.value.BrandId = 0;
    //   StockInHandObj.value.ModelNumberId = 0;
    //   StockInHandObj.value.SizeId = 0;
    //   emit("clearitem", ItemData);

    //   itemDisabled.value = false;
    //   itemConfigDisabled.value = false;
    //   wariningPopup.value = false;
    //   ItemInfoIcon.value = false;

    //   if (props.LasTTransactionDocType) {
    //     ItemLastTranspopup.value = false;
    //     ItemLastTransicon.value = false;
    //   }
    // }

    function IsClear() {
      debugger;
      if (
        // && route.query.param == "DC" && props.SelectedDCType == 1
        props.commonItemProps?.IsFilter == 3 &&
        ItemFields.value.BatchRequired &&
        ItemData.IsEdit == 0
      ) {
        // Only clear specific fields for batch-required items
        // This allows adding multiple items with different batch numbers
        // ItemData.ItemQuantity = "";
        ItemData.BatchNo = "";
        ItemData.SupplierBarCode = "";
        // ItemData.ExpiryDate = ""; // Set to empty string instead of ref()
        ItemData.IsFreeItem = "0";

        ItemData.IsFreeQtyItem = "0";

        // Reset validation only for these specific fields
        // resetField('ExpiryDate'); // Explicitly reset the validation
      } else {
        // Clear all fields for non-batch items
        ItemData.ItemQuantity = "";
        ItemData.PackSizeId = ref();
        ItemData.UOM = ref();
        ItemData.Brand = ref();
        ItemData.ModelNumber = ref();
        ItemData.Size = ref();
        resetForm();
        Object.assign(ItemData, copyinsert_data);
        StockInHandObj.value.BrandId = 0;
        StockInHandObj.value.ModelNumberId = 0;
        StockInHandObj.value.SizeId = 0;
        ItemData.ExpiryDate = "";
        ItemData.ManufactureDate = ref();
        ItemData.IsFreeItem = "0";
        ItemData.IsFreeQtyItem = "0";
        LoadIssueNo.value.IssueNoOption = [];
        emit("clearitem", ItemData);

        itemDisabled.value = false;
        itemConfigDisabled.value = false;
        wariningPopup.value = false;
        ItemInfoIcon.value = false;

        if (props.LasTTransactionDocType) {
          ItemLastTranspopup.value = false;
          ItemLastTransicon.value = false;
        }
      }
    }

    async function IsFooterClear(ClearValue) {
      debugger;
      ItemData.ItemQuantity = "";
      ItemData.PackSizeId = ref();
      ItemData.UOM = ref();
      ItemData.Brand = ref();
      ItemData.ModelNumber = ref();
      ItemData.Size = ref();
      LoadIssueNo.value.IssueNoOption = [];
      resetForm();

      Object.assign(ItemData, copyinsert_data);
      StockInHandObj.value.BrandId = 0;
      StockInHandObj.value.ModelNumberId = 0;
      StockInHandObj.value.SizeId = 0;
      await LoadItemConfigurations();
      ItemData.ExpiryDate = ""; // Set to empty string instead of ref()
      ItemData.ManufactureDate = ""; // Set to empty string instead of ref()
      ItemData.IsFreeItem = "0";
      ItemData.IsFreeQtyItem = "0";

      ItemFields.value.BatchRequired = false;
      ItemFields.value.ExpiryDtRequired = false;
      // ItemFields.value.ManufactureDate = false;
      ItemFields.value.ManufactureDtRequired = false;

      // emit("clearitem", ItemData);

      itemDisabled.value = false;
      itemConfigDisabled.value = false;
      wariningPopup.value = false;
      ItemInfoIcon.value = false;

      if (props.LasTTransactionDocType) {
        ItemLastTranspopup.value = false;
        ItemLastTransicon.value = false;
      }

      // if (ItemData.IsEdit == 0) {
      //   updatename.value = "Update";
      // } else {
      //   updatename.value = "Add";
      // }

      if (ClearValue == 0) {
        updatename.value = "Add";
      } else {
        updatename.value = "Update";
      }
    }

    // const { resetForm } = useForm();
    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      AddBtnLoader.value = true;
      if (ItemData.IsEdit == 0) {
        if (ItemData.ItemId != 0) {
          await IsAdd(); // Ensure IsAdd() completes before resetting the form
          ItemInfoIcon.value = false;
        } else {
          toast.add({
            severity: "warn",
            summary: "Item Name Required",
            detail: "Please provide the item name before add.",
            life: 3000,
          });
          AddBtnLoader.value = false;
        }
      } else {
        await AmountCalculation(); // Ensure AmountCalculation() completes before resetting the form
        ItemInfoIcon.value = false;
      }
      AddBtnLoader.value = false;
    });

    // const RoomDropdown: any = ref({
    //   ItemRoomoption: [],
    // });
    // const RackDropdown: any = ref({
    //   ItemRackoption: [],
    // });
    // const RowDropdown: any = ref({
    //   ItemRowoption: [],
    // });
    // const BoxDropdown: any = ref({
    //   ItemBoxoption: [],
    // });

    //Room Load Based on Store
    // async function LoadRoom() {
    //   debugger;
    //   try {
    //     let StoreID = props.commonItemProps.storeId;
    //     const result = await roomService.getRoomList();
    //     console.log(result);
    //     RoomDropdown.value.ItemRoomoption = result["result"]
    //       .filter((i1) => i1.StoreId == StoreID && i1.IsActive == true)
    //       .map((item) => {
    //         item.name = item.Name;
    //         item.value = item.Id;
    //         return item;
    //       });
    //   } catch (error) { }
    // }

    // //Rack Load by Room Id
    // async function LoadRack() {
    //   debugger;
    //   try {
    //     let StoreID = props.commonItemProps.storeId;
    //     const result = await RackService.getRackList();
    //     console.log(result);
    //     RackDropdown.value.ItemRackoption = result["result"]
    //       .filter((i1) => i1.StoreId == StoreID && i1.IsActive == true)
    //       .map((item) => {
    //         item.name = item.Name;
    //         item.value = item.Id;
    //         return item;
    //       });
    //   } catch (error) { }
    // }

    // //Row Load by Rack Id
    // async function LoadRow() {
    //   debugger;
    //   try {
    //     let StoreID = props.commonItemProps.storeId;
    //     const result = await RowService.getRowList();
    //     console.log(result);
    //     RowDropdown.value.ItemRowoption = result["result"]
    //       .filter((i1) => i1.StoreId == StoreID && i1.IsActive == true)
    //       .map((item) => {
    //         item.name = item.Name;
    //         item.value = item.Id;
    //         return item;
    //       });
    //   } catch (error) { }
    // }

    // //Box Load by Row Id
    // async function LoadBox() {
    //   debugger;
    //   try {
    //     let StoreID = props.commonItemProps.storeId;
    //     const result = await BoxService.getBoxList();
    //     console.log(result);
    //     BoxDropdown.value.ItemBoxoption = result["result"]
    //       .filter((item) => item.StoreId == StoreID)
    //       .map((item: any) => {
    //         item.name = item.Name;
    //         item.value = item.Id;
    //         return item;
    //       });
    //   } catch (error) { }
    // }

    function ExcelDataImport(ExcelData) {
      debugger;
      emit("ExcelData", ExcelData);
    }

    // function OnChangeBox() {
    //   debugger;
    //   let value = ItemData.BoxId;
    //   console.log(value);
    //   if (value) {
    //     let options: any = BoxDropdown.value.ItemBoxoption.find(
    //       (item) => item["value"] == value
    //     );
    //     ItemData.RoomId = options["RoomId"];
    //     ItemData.RowId = options["RowId"];
    //     ItemData.RackId = options["RackId"];
    //     ItemData.RoomName = options["RoomName"];
    //     ItemData.RowName = options["RowName"];
    //     ItemData.RackName = options["RackName"];
    //     ItemData.BoxName = options["Name"];
    //   }
    // }

    let supplierDetailsList: any = ref([]);
    async function getSupplierDetailsItemId(data) {
      try {
        const result =
          await WithoutStockAffectService.GetSupplierDetailsByItemId(
            data.ItemId,
            data.Brand,
            data.ModelNumber,
            data.Size,
            data.UOM
          );
        console.log(result);
        // supplierDetailsList.value = result["result"];
        if (Array.isArray(result["result"])) {
          // Get the last 10 items
          supplierDetailsList.value = result["result"].slice(-10);
        } else {
          console.error(
            "Unexpected result format: result['result'] is not an array."
          );
          supplierDetailsList.value = [];
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function GetLastTransactionDetails(data) {
      debugger;
      ItemLastTranspopup.value = true;

      try {
        const result = await CommonService.GetLastTransactionDetails(
          usersData.OrganizationId,
          FromStoreBranchId,
          props.LasTTransactionDocType,
          props.commonItemProps.storeId,
          data.ItemId
        );

        let count = 0;
        LastTrasactionDetails.value = result["result"].map((item) => {
          count = count + 1;
          item.RowNumber = count;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    const maxDate = ref(new Date());
    // maxDate.value.setDate(maxDate.value.getDate() - 1); // Set maximum date to yesterday

    // Create a date 5 days from today for minimum expiry date
    const minExpiryDate = computed(() => {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date;
    });

    const onIsFreeItemChange = () => {
      debugger;

      if (ItemData.IsFreeQtyItem == "1") {
        toast.add({
          severity: "info",
          summary: "Information",
          detail:
            "You can only add either free quantity or promo item at a time.",
          life: 3000,
        });
      }

      ItemData.IsFreeQtyItem = ItemData.IsFreeItem == "1" ? "0" : "1";
    };

    const onIsFreeQtyItemChange = () => {
      debugger;
      if (ItemData.IsFreeItem == "1") {
        toast.add({
          severity: "info",
          summary: "Information",
          detail:
            "You can only add either free quantity or promo item at a time.",
          life: 3000,
        });
      }

      ItemData.IsFreeItem = ItemData.IsFreeQtyItem == "1" ? "0" : "1";
    };

    const handleEnterPress = () => {
      if (ItemData.BatchChecked && ItemData.BatchNo.trim() !== "") {
        // Set the flag to true before showing the popup
        BatchNoFlag.value = true;
        IsSubmit();
      }
    };

    return {
      updatename,
      FieldDisabled,
      loadBasedonConsumeOrService,
      CategoryOnChange,
      // PackSize,
      ItemCategoryname,
      LoadCategoryName,
      LoadItemName,
      ItemData,
      AddData,
      getValues,
      ItemOnChange,
      // PackageSizeOnChange,
      // LoadPackSize,
      AddItems,
      AddItemsQty,
      IsClear,
      IsFooterClear,
      Editmodel,
      EditmodelQty,
      IsAdd,
      addQuantity,
      dataItems,
      IsUpdate,
      AmountCalculation,
      QuantityDataChange,
      ItemDataTotalValue,
      wariningPopup,
      warningmsgcontent,
      LoadItem,
      ItemCheck,
      labelQuantity,
      ItemFields,
      IsSubmit,
      itemDisabled,
      itemConfigDisabled,
      LoadUOM,
      UOM,
      UOMOnChange,
      BrandDropdown,
      ModelNumberDropdown,
      SizeDropdown,
      BrandOnChange,
      ModelNumberOnChange,
      SizeOnChange,
      LoadReason,
      LoadIssueNo,
      ReasonOnchange,
      // RoomDropdown,
      // RackDropdown,
      // RowDropdown,
      // BoxDropdown,
      // LoadRoom,
      // LoadRack,
      // LoadRow,
      // LoadBox,
      ExcelDataImport,
      // OnChangeBox,
      maxDate,
      minExpiryDate,
      POFlag,
      UnitRateZero,
      // CurrentUOM,
      ItemInfoIcon,
      ItemInfoPop,
      getSupplierDetailsItemId,
      supplierDetailsList,
      loading,
      ItemInfoHeaders,
      ItemLastTransicon,
      ItemLastTranspopup,
      GetLastTransactionDetails,
      LastTrasactionDetails,
      ItemLastTransInfoHeaders,
      AddBtnLoader,
      onIsFreeItemChange,
      onIsFreeQtyItemChange,
      handleEnterPress,
      DocNoOnchange,
      CurrentUOM,
      BatchNokeyup,
      SupplierCheckedOnChange,
    };
  },
});
</script>
<style lang="scss">
.field .Itemdisplay {
  display: none;
}

.itemdata-checked {
  height: 16px;
  width: 40px;
  position: absolute !important;
  top: 3px;
  right: 15px;
}

.itemdata-checked .p-inputswitch-slider:before {
  width: 0.75rem;
  height: 0.75rem;
  top: 11px;
}
</style>
